import React from "react";

export interface IconProps {
  name:
    | "lock"
    | "cross"
    | "error"
    | "minus"
    | "plus"
    | "search"
    | "activity"
    | "activity-2"
    | "chart"
    | "Arrow-right"
    | "Arrow-right-secondary"
    | "import"
    | "drag"
    | "history"
    | "book"
    | "expand"
    | "addEmployee"
    | "createModule"
    | "createSequence"
    | "reportedIssues"
    | "email"
    | "call"
    | "clock"
    | "calendar"
    | "upgrade"
    | "offer"
    | "team"
    | "like"
    | "filter"
    | "link"
    | "camera"
    | "key"
    | "support"
    | "sequence"
    | "joiningDate"
    | "role"
    | "status"
    | "filterLines"
    | "delete"
    | "growArrow"
    | "edit"
    | "archive"
    | "duplicate"
    | "createDate"
    | "action"
    | "exit"
    | "skip"
    | "google"
    | "microsoft"
    | "linkedIn"
    | "show"
    | "hide"
    | "empty-content"
    | "property1-default"
    | "property1-active"
    | "property2-default"
    | "property2-active"
    | "property3-default"
    | "property3-active"
    | "property4-default"
    | "property4-active"
    | "property5-default"
    | "property5-active"
    | "property6-default"
    | "property7-default"
    | "property8-default"
    | "property9-default"
    | "property10-default"
    | "property11-default"
    | "property12-default"
    | "home"
    | "resources"
    | "green"
    | "aqua"
    | "yellow"
    | "watermelon"
    | "gray"
    | "orangered"
    | "blue"
    | "tick-circle"
    | "star"
    | "more"
    | "info-circle"
    | "info-circle-2"
    | "tick"
    | "error"
    | "error-2"
    | "play"
    | "left"
    | "right"
    | "up"
    | "down"
    | "white-circle-tick"
    | "white-circle-cross"
    | "comment"
    | "small-document"
    | "send"
    | "watch-color"
    | "round-small-color"
    | "soap-color"
    | "document-color"
    | "danger-color"
    | "logout"
    | "dot-action"
    | "edit-2"
    | "round-cross"
    | "copy"
    | "delete-2"
    | "lock-2"
    | "unlock"
    | "arrow-left"
    | "clipboard-text"
    | "arrow-bottom"
    | "mac"
    | "windwos"
    | "assign-content";
  size?: number;
  color?: string;
  className?: string;
  variant?:
    | "stroke"
    | "socialIcons"
    | "preview"
    | "graphics"
    | "sidebar"
    | "circles"
    | "bold"
    | "arrow";
}

const Icons: React.FC<IconProps> = ({
  name,
  size = 16,
  color = "black",
  variant,
  className,
}) => {
  const iconStyles = {
    width: `${size}px`,
    height: `${size}px`,
    fill: color,
  };

  let icon = null;

  switch (name) {
    case "lock":
      icon = (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M6 10V8C6 4.69 7 2 12 2C17 2 18 4.69 18 8V10"
            stroke="#232323"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M12 18.5C13.3807 18.5 14.5 17.3807 14.5 16C14.5 14.6193 13.3807 13.5 12 13.5C10.6193 13.5 9.5 14.6193 9.5 16C9.5 17.3807 10.6193 18.5 12 18.5Z"
            stroke="#232323"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M17 22H7C3 22 2 21 2 17V15C2 11 3 10 7 10H17C21 10 22 11 22 15V17C22 21 21 22 17 22Z"
            stroke="#232323"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      );
      break;
    case "cross":
      icon = (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M20.7811 4.28033C21.074 3.98744 21.074 3.51256 20.7811 3.21967C20.4882 2.92678 20.0134 2.92678 19.7205 3.21967L12.0004 10.9397L4.28033 3.21967C3.98744 2.92678 3.51256 2.92678 3.21967 3.21967C2.92678 3.51256 2.92678 3.98744 3.21967 4.28033L10.9397 12.0004L3.21967 19.7205C2.92678 20.0134 2.92678 20.4882 3.21967 20.7811C3.51256 21.074 3.98744 21.074 4.28033 20.7811L12.0004 13.0611L19.7205 20.7811C20.0134 21.074 20.4882 21.074 20.7811 20.7811C21.074 20.4882 21.074 20.0134 20.7811 19.7205L13.0611 12.0004L20.7811 4.28033Z"
            fill="#232323"
          />
        </svg>
      );
      break;
    case "error":
      icon = (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M12 9V14"
            stroke={color ? color : "#232323"}
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M11.9999 21.41H5.93993C2.46993 21.41 1.01993 18.93 2.69993 15.9L5.81993 10.28L8.75993 5C10.5399 1.79 13.4599 1.79 15.2399 5L18.1799 10.29L21.2999 15.91C22.9799 18.94 21.5199 21.42 18.0599 21.42H11.9999V21.41Z"
            stroke={color ? color : "#232323"}
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M11.9946 17H12.0036"
            stroke={color ? color : "#232323"}
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      );
      break;
    case "minus":
      icon = (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M4.66602 12H19.3327"
            stroke="#232323"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      );
      break;
    case "plus":
      icon = (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M4.66602 12H19.3327"
            stroke={color ? color : "#232323"}
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M12 19.3337V4.66699"
            stroke={color ? color : "#232323"}
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      );
      break;
    case "search":
      icon = (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M11.5 21C16.7467 21 21 16.7467 21 11.5C21 6.25329 16.7467 2 11.5 2C6.25329 2 2 6.25329 2 11.5C2 16.7467 6.25329 21 11.5 21Z"
            stroke="#232323"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M22 22L20 20"
            stroke="#232323"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      );
      break;
    case "activity":
      icon = (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M4 7H20"
            stroke="#232323"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M9 12H20"
            stroke="#232323"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M4 17L20 17"
            stroke="#232323"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      );
      break;
    case "activity-2":
      icon = (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="25"
          height="26"
          viewBox="0 0 25 26"
          fill="none"
        >
          <path
            d="M12.0186 4.41016C8.70862 4.41016 6.01862 7.10016 6.01862 10.4102V13.3002C6.01862 13.9102 5.75862 14.8402 5.44862 15.3602L4.29862 17.2702C3.58862 18.4502 4.07862 19.7602 5.37862 20.2002C9.68862 21.6402 14.3386 21.6402 18.6486 20.2002C19.8586 19.8002 20.3886 18.3702 19.7286 17.2702L18.5786 15.3602C18.2786 14.8402 18.0186 13.9102 18.0186 13.3002V10.4102C18.0186 7.11016 15.3186 4.41016 12.0186 4.41016Z"
            stroke="#3C3C3C"
            stroke-width="1.5"
            stroke-miterlimit="10"
            stroke-linecap="round"
          />
          <path
            d="M13.8719 4.69945C13.5619 4.60945 13.2419 4.53945 12.9119 4.49945C11.9519 4.37945 11.0319 4.44945 10.1719 4.69945C10.4619 3.95945 11.1819 3.43945 12.0219 3.43945C12.8619 3.43945 13.5819 3.95945 13.8719 4.69945Z"
            stroke="#3C3C3C"
            stroke-width="1.5"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M15.0195 20.5605C15.0195 22.2105 13.6695 23.5605 12.0195 23.5605C11.1995 23.5605 10.4395 23.2205 9.89953 22.6805C9.35953 22.1405 9.01953 21.3805 9.01953 20.5605"
            stroke="#3C3C3C"
            stroke-width="1.5"
            stroke-miterlimit="10"
          />
          {/* <circle cx="22" cy="3.5" r="3" fill="#F15845" /> */}
        </svg>
      );
      break;
    case "chart":
      icon = (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M21 22.75H3C2.59 22.75 2.25 22.41 2.25 22C2.25 21.59 2.59 21.25 3 21.25H21C21.41 21.25 21.75 21.59 21.75 22C21.75 22.41 21.41 22.75 21 22.75Z"
            fill="#232323"
          />
          <path
            d="M5.59998 19.75H4C3.04 19.75 2.25 18.96 2.25 18V9.38001C2.25 8.42 3.04 7.63 4 7.63H5.59998C6.55998 7.63 7.34997 8.42 7.34997 9.38001V18C7.34997 18.96 6.55998 19.75 5.59998 19.75ZM4 9.12C3.86 9.12 3.75 9.23 3.75 9.37V18C3.75 18.14 3.86 18.25 4 18.25H5.59998C5.73998 18.25 5.84998 18.14 5.84998 18V9.38001C5.84998 9.24001 5.73998 9.13001 5.59998 9.13001H4V9.12Z"
            fill="#232323"
          />
          <path
            d="M12.8002 19.75H11.2002C10.2402 19.75 9.4502 18.96 9.4502 18V6.19C9.4502 5.23 10.2402 4.44 11.2002 4.44H12.8002C13.7602 4.44 14.5502 5.23 14.5502 6.19V18C14.5502 18.96 13.7602 19.75 12.8002 19.75ZM11.2002 5.94C11.0602 5.94 10.9502 6.05 10.9502 6.19V18C10.9502 18.14 11.0602 18.25 11.2002 18.25H12.8002C12.9402 18.25 13.0502 18.14 13.0502 18V6.19C13.0502 6.05 12.9402 5.94 12.8002 5.94H11.2002Z"
            fill="#232323"
          />
          <path
            d="M19.9999 19.75H18.3999C17.4399 19.75 16.6499 18.96 16.6499 18V3C16.6499 2.04 17.4399 1.25 18.3999 1.25H19.9999C20.9599 1.25 21.7499 2.04 21.7499 3V18C21.7499 18.96 20.9599 19.75 19.9999 19.75ZM18.3999 2.75C18.2599 2.75 18.1499 2.86 18.1499 3V18C18.1499 18.14 18.2599 18.25 18.3999 18.25H19.9999C20.1399 18.25 20.2499 18.14 20.2499 18V3C20.2499 2.86 20.1399 2.75 19.9999 2.75H18.3999Z"
            fill="#232323"
          />
        </svg>
      );
      break;
    case "Arrow-right":
      icon = (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M14.4297 5.92999L20.4997 12L14.4297 18.07"
            stroke="#232323"
            stroke-width="1.5"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M3.5 12H20.33"
            stroke="#232323"
            stroke-width="1.5"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      );
      break;
    case "Arrow-right-secondary":
      icon = (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
        >
          <path
            d="M12.0249 4.94165L17.0832 9.99998L12.0249 15.0583"
            stroke="#4A154B"
            stroke-width="1.5"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M2.9165 10H16.9415"
            stroke="#4A154B"
            stroke-width="1.5"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      );
      break;
    case "import":
      icon = (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M15.8092 24H8.19085C2.45375 24 0 21.6 0 15.9886V15.84C0 10.7657 2.04479 8.32 6.62512 7.89714C7.0925 7.86286 7.53651 8.20571 7.58325 8.67429C7.62999 9.14286 7.27945 9.56571 6.7887 9.61143C3.11977 9.94286 1.75268 11.6343 1.75268 15.8514V16C1.75268 20.6514 3.43525 22.2971 8.19085 22.2971H15.8092C20.5648 22.2971 22.2473 20.6514 22.2473 16V15.8514C22.2473 11.6114 20.8569 9.92 17.1178 9.61143C16.6388 9.56571 16.2765 9.15429 16.3233 8.68571C16.37 8.21714 16.779 7.86286 17.2697 7.90857C21.9202 8.29714 24 10.7543 24 15.8629V16.0114C24 21.6 21.5463 24 15.8092 24Z"
            fill="#232323"
          />
          <path
            d="M11.9999 16.4343C11.5208 16.4343 11.1235 16.0457 11.1235 15.5771V0.857143C11.1235 0.388571 11.5208 0 11.9999 0C12.4789 0 12.8762 0.388571 12.8762 0.857143V15.5771C12.8762 16.0571 12.4789 16.4343 11.9999 16.4343Z"
            fill="#232323"
          />
          <path
            d="M12.0001 17.7143C11.7781 17.7143 11.5561 17.6343 11.3809 17.4629L7.46654 13.6343C7.12769 13.3029 7.12769 12.7543 7.46654 12.4229C7.80539 12.0914 8.36625 12.0914 8.7051 12.4229L12.0001 15.6457L15.2952 12.4229C15.634 12.0914 16.1949 12.0914 16.5337 12.4229C16.8726 12.7543 16.8726 13.3029 16.5337 13.6343L12.6194 17.4629C12.4441 17.6343 12.2221 17.7143 12.0001 17.7143Z"
            fill="#232323"
          />
        </svg>
      );
      break;
    case "drag":
      icon = (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M16.0801 2.75C15.3897 2.75 14.8301 3.30964 14.8301 4C14.8301 4.69036 15.3897 5.25 16.0801 5.25C16.7704 5.25 17.3301 4.69035 17.3301 4C17.3301 3.30965 16.7704 2.75 16.0801 2.75ZM13.3301 4C13.3301 2.48122 14.5613 1.25 16.0801 1.25C17.5989 1.25 18.8301 2.48121 18.8301 4C18.8301 5.51879 17.5989 6.75 16.0801 6.75C14.5613 6.75 13.3301 5.51878 13.3301 4Z"
            fill="#232323"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M16.0801 18.75C15.3897 18.75 14.8301 19.3096 14.8301 20C14.8301 20.6904 15.3897 21.25 16.0801 21.25C16.7704 21.25 17.3301 20.6904 17.3301 20C17.3301 19.3096 16.7704 18.75 16.0801 18.75ZM13.3301 20C13.3301 18.4812 14.5613 17.25 16.0801 17.25C17.5989 17.25 18.8301 18.4812 18.8301 20C18.8301 21.5188 17.5989 22.75 16.0801 22.75C14.5613 22.75 13.3301 21.5188 13.3301 20Z"
            fill="#232323"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M7.00001 2.75C6.30965 2.75 5.75 3.30965 5.75 4C5.75 4.69035 6.30965 5.25 7.00001 5.25C7.69036 5.25 8.25 4.69036 8.25 4C8.25 3.30964 7.69036 2.75 7.00001 2.75ZM4.25 4C4.25 2.48121 5.48123 1.25 7.00001 1.25C8.51879 1.25 9.75 2.48122 9.75 4C9.75 5.51878 8.51879 6.75 7.00001 6.75C5.48123 6.75 4.25 5.51879 4.25 4Z"
            fill="#232323"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M7.00001 18.75C6.30965 18.75 5.75 19.3096 5.75 20C5.75 20.6904 6.30965 21.25 7.00001 21.25C7.69036 21.25 8.25 20.6904 8.25 20C8.25 19.3096 7.69036 18.75 7.00001 18.75ZM4.25 20C4.25 18.4812 5.48123 17.25 7.00001 17.25C8.51879 17.25 9.75 18.4812 9.75 20C9.75 21.5188 8.51879 22.75 7.00001 22.75C5.48123 22.75 4.25 21.5188 4.25 20Z"
            fill="#232323"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M16.0801 10.75C15.3897 10.75 14.8301 11.3096 14.8301 12C14.8301 12.6904 15.3897 13.25 16.0801 13.25C16.7704 13.25 17.3301 12.6904 17.3301 12C17.3301 11.3096 16.7704 10.75 16.0801 10.75ZM13.3301 12C13.3301 10.4812 14.5613 9.25 16.0801 9.25C17.5989 9.25 18.8301 10.4812 18.8301 12C18.8301 13.5188 17.5989 14.75 16.0801 14.75C14.5613 14.75 13.3301 13.5188 13.3301 12Z"
            fill="#232323"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M7.00001 10.75C6.30965 10.75 5.75 11.3096 5.75 12C5.75 12.6904 6.30965 13.25 7.00001 13.25C7.69036 13.25 8.25 12.6904 8.25 12C8.25 11.3096 7.69036 10.75 7.00001 10.75ZM4.25 12C4.25 10.4812 5.48123 9.25 7.00001 9.25C8.51879 9.25 9.75 10.4812 9.75 12C9.75 13.5188 8.51879 14.75 7.00001 14.75C5.48123 14.75 4.25 13.5188 4.25 12Z"
            fill="#232323"
          />
        </svg>
      );
      break;
    case "history":
      icon = (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M14.55 22.42C14.22 22.42 13.91 22.2 13.82 21.86C13.71 21.46 13.95 21.05 14.36 20.94C18.42 19.87 21.25 16.19 21.25 11.99C21.25 6.89 17.1 2.74 12 2.74C7.67 2.74 4.83 5.27 3.5 6.8H6.44C6.85 6.8 7.19 7.14 7.19 7.55C7.19 7.96 6.86 8.31 6.44 8.31H2.01C1.96 8.31 1.87 8.3 1.8 8.28C1.71 8.25 1.63 8.21 1.56 8.16C1.47 8.1 1.4 8.02 1.35 7.93C1.3 7.84 1.26 7.73 1.25 7.62C1.25 7.59 1.25 7.57 1.25 7.54V3C1.25 2.59 1.59 2.25 2 2.25C2.41 2.25 2.75 2.59 2.75 3V5.39C4.38 3.64 7.45 1.25 12 1.25C17.93 1.25 22.75 6.07 22.75 12C22.75 16.88 19.46 21.16 14.74 22.4C14.68 22.41 14.61 22.42 14.55 22.42Z"
            fill="#232323"
          />
          <path
            d="M11.29 22.73C11.27 22.73 11.25 22.72 11.24 22.72C10.16 22.65 9.1 22.41 8.1 22.02C7.81 21.91 7.61 21.62 7.62 21.31C7.62 21.22 7.64 21.13 7.67 21.05C7.82 20.67 8.27 20.48 8.64 20.62C9.51 20.96 10.42 21.16 11.34 21.23C11.73 21.25 12.04 21.59 12.04 21.99L12.03 22.03C12.01 22.42 11.68 22.73 11.29 22.73ZM5.78 20.58C5.61 20.58 5.45 20.52 5.31 20.42C4.47 19.74 3.73 18.95 3.13 18.07C3.04 17.94 2.99 17.8 2.99 17.65C2.99 17.4 3.11 17.17 3.32 17.03C3.65 16.8 4.13 16.89 4.36 17.21C4.36 17.22 4.36 17.22 4.36 17.22C4.37 17.23 4.38 17.25 4.39 17.26C4.91 18.01 5.54 18.68 6.25 19.24C6.42 19.38 6.53 19.59 6.53 19.82C6.53 19.99 6.48 20.16 6.37 20.3C6.22 20.48 6.01 20.58 5.78 20.58ZM2.44 15.7C2.11 15.7 1.82 15.49 1.73 15.18C1.41 14.15 1.25 13.08 1.25 12V11.99C1.26 11.58 1.59 11.25 2 11.25C2.41 11.25 2.75 11.59 2.75 12C2.75 12.94 2.89 13.86 3.16 14.73C3.18 14.81 3.19 14.88 3.19 14.96C3.19 15.28 2.98 15.57 2.66 15.67C2.59 15.69 2.52 15.7 2.44 15.7Z"
            fill="#232323"
          />
        </svg>
      );
      break;
    case "book":
      icon = (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M22 16.74V4.67C22 3.47 21.02 2.58 19.83 2.68H19.77C17.67 2.86 14.48 3.93 12.7 5.05L12.53 5.16C12.24 5.34 11.76 5.34 11.47 5.16L11.22 5.01C9.44 3.9 6.26 2.84 4.16 2.67C2.97 2.57 2 3.47 2 4.66V16.74C2 17.7 2.78 18.6 3.74 18.72L4.03 18.76C6.2 19.05 9.55 20.15 11.47 21.2L11.51 21.22C11.78 21.37 12.21 21.37 12.47 21.22C14.39 20.16 17.75 19.05 19.93 18.76L20.26 18.72C21.22 18.6 22 17.7 22 16.74Z"
            fill="white"
            stroke="#232323"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M12 5.49V20.49"
            stroke="#232323"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M7.75 8.49H5.5"
            stroke="#232323"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M8.5 11.49H5.5"
            stroke="#232323"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      );
      break;
    case "expand":
      icon = (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0_386_3320)">
            <path
              d="M20 4L4 20"
              stroke="#232323"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M20 9V4H15"
              stroke="#232323"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M4 15V20H9"
              stroke="#232323"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M4 4L20 20"
              stroke="#232323"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M4 9V4H9"
              stroke="#232323"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M20 15V20H15"
              stroke="#232323"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </g>
          <defs>
            <clipPath id="clip0_386_3320">
              <rect width="24" height="24" fill="white" />
            </clipPath>
          </defs>
        </svg>
      );
      break;
    case "addEmployee":
      icon = (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M12 12.75C8.83 12.75 6.25 10.17 6.25 7C6.25 3.83 8.83 1.25 12 1.25C15.17 1.25 17.75 3.83 17.75 7C17.75 10.17 15.17 12.75 12 12.75ZM12 2.75C9.66 2.75 7.75 4.66 7.75 7C7.75 9.34 9.66 11.25 12 11.25C14.34 11.25 16.25 9.34 16.25 7C16.25 4.66 14.34 2.75 12 2.75Z"
            fill="#232323"
          />
          <path
            d="M3.41016 22.75C3.00016 22.75 2.66016 22.41 2.66016 22C2.66016 17.73 6.85015 14.25 12.0002 14.25C13.0102 14.25 14.0001 14.38 14.9601 14.65C15.3601 14.76 15.5902 15.17 15.4802 15.57C15.3702 15.97 14.9602 16.2 14.5602 16.09C13.7402 15.86 12.8802 15.75 12.0002 15.75C7.68015 15.75 4.16016 18.55 4.16016 22C4.16016 22.41 3.82016 22.75 3.41016 22.75Z"
            fill="#232323"
          />
          <path
            d="M18 22.75C16.82 22.75 15.7 22.31 14.83 21.52C14.48 21.22 14.17 20.85 13.93 20.44C13.49 19.72 13.25 18.87 13.25 18C13.25 16.75 13.73 15.58 14.59 14.69C15.49 13.76 16.7 13.25 18 13.25C19.36 13.25 20.65 13.83 21.53 14.83C22.31 15.7 22.75 16.82 22.75 18C22.75 18.38 22.7 18.76 22.6 19.12C22.5 19.57 22.31 20.04 22.05 20.45C21.22 21.87 19.66 22.75 18 22.75ZM18 14.75C17.11 14.75 16.29 15.1 15.67 15.73C15.08 16.34 14.75 17.14 14.75 18C14.75 18.59 14.91 19.17 15.22 19.67C15.38 19.95 15.59 20.2 15.83 20.41C16.43 20.96 17.2 21.26 18 21.26C19.13 21.26 20.2 20.66 20.78 19.69C20.95 19.41 21.08 19.09 21.15 18.78C21.22 18.52 21.25 18.27 21.25 18.01C21.25 17.21 20.95 16.44 20.41 15.84C19.81 15.14 18.93 14.75 18 14.75Z"
            fill="#232323"
          />
          <path
            d="M15.9655 18.5177C15.8311 18.3834 15.7462 18.1996 15.7462 17.9874C15.7462 17.5773 16.0856 17.2379 16.4958 17.2379L19.4798 17.2379C19.8899 17.2379 20.2293 17.5773 20.2293 17.9874C20.2293 18.3975 19.8899 18.7369 19.4798 18.7369L16.4958 18.737C16.2836 18.737 16.0998 18.6521 15.9655 18.5177Z"
            fill="#232323"
          />
          <path
            d="M17.4638 20.0454C17.3294 19.9111 17.2446 19.7272 17.2446 19.5151L17.2446 16.5311C17.2446 16.121 17.584 15.7816 17.9941 15.7816C18.4043 15.7816 18.7437 16.121 18.7437 16.5311L18.7437 19.5151C18.7437 19.9252 18.4043 20.2646 17.9941 20.2646C17.782 20.2646 17.5981 20.1798 17.4638 20.0454Z"
            fill="#232323"
          />
        </svg>
      );
      break;
    case "createModule":
      icon = (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M17.6201 9.62H12.3701C11.9601 9.62 11.6201 9.28 11.6201 8.87C11.6201 8.46 11.9601 8.12 12.3701 8.12H17.6201C18.0301 8.12 18.3701 8.46 18.3701 8.87C18.3701 9.28 18.0401 9.62 17.6201 9.62Z"
            fill="#232323"
          />
          <path
            d="M7.12006 10.38C6.93006 10.38 6.74006 10.31 6.59006 10.16L5.84006 9.41C5.55006 9.12 5.55006 8.64 5.84006 8.35C6.13006 8.06 6.61006 8.06 6.90006 8.35L7.12006 8.57L8.84006 6.85C9.13006 6.56 9.61006 6.56 9.90006 6.85C10.1901 7.14 10.1901 7.62 9.90006 7.91L7.65006 10.16C7.51006 10.3 7.32006 10.38 7.12006 10.38Z"
            fill="#232323"
          />
          <path
            d="M17.6201 16.62H12.3701C11.9601 16.62 11.6201 16.28 11.6201 15.87C11.6201 15.46 11.9601 15.12 12.3701 15.12H17.6201C18.0301 15.12 18.3701 15.46 18.3701 15.87C18.3701 16.28 18.0401 16.62 17.6201 16.62Z"
            fill="#232323"
          />
          <path
            d="M7.12006 17.38C6.93006 17.38 6.74006 17.31 6.59006 17.16L5.84006 16.41C5.55006 16.12 5.55006 15.64 5.84006 15.35C6.13006 15.06 6.61006 15.06 6.90006 15.35L7.12006 15.57L8.84006 13.85C9.13006 13.56 9.61006 13.56 9.90006 13.85C10.1901 14.14 10.1901 14.62 9.90006 14.91L7.65006 17.16C7.51006 17.3 7.32006 17.38 7.12006 17.38Z"
            fill="#232323"
          />
          <path
            d="M15 22.75H9C3.57 22.75 1.25 20.43 1.25 15V9C1.25 3.57 3.57 1.25 9 1.25H15C20.43 1.25 22.75 3.57 22.75 9V15C22.75 20.43 20.43 22.75 15 22.75ZM9 2.75C4.39 2.75 2.75 4.39 2.75 9V15C2.75 19.61 4.39 21.25 9 21.25H15C19.61 21.25 21.25 19.61 21.25 15V9C21.25 4.39 19.61 2.75 15 2.75H9Z"
            fill="#232323"
          />
        </svg>
      );
      break;
    case "createSequence":
      icon = (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M15 22.75H9C3.57 22.75 1.25 20.43 1.25 15V9C1.25 3.57 3.57 1.25 9 1.25H11C11.41 1.25 11.75 1.59 11.75 2C11.75 2.41 11.41 2.75 11 2.75H9C4.39 2.75 2.75 4.39 2.75 9V15C2.75 19.61 4.39 21.25 9 21.25H15C19.61 21.25 21.25 19.61 21.25 15V13C21.25 12.59 21.59 12.25 22 12.25C22.41 12.25 22.75 12.59 22.75 13V15C22.75 20.43 20.43 22.75 15 22.75Z"
            fill="#232323"
          />
          <path
            d="M8.49984 17.69C7.88984 17.69 7.32984 17.47 6.91984 17.07C6.42984 16.58 6.21984 15.87 6.32984 15.12L6.75984 12.11C6.83984 11.53 7.21984 10.78 7.62984 10.37L15.5098 2.49C17.4998 0.5 19.5198 0.5 21.5098 2.49C22.5998 3.58 23.0898 4.69 22.9898 5.8C22.8998 6.7 22.4198 7.58 21.5098 8.48L13.6298 16.36C13.2198 16.77 12.4698 17.15 11.8898 17.23L8.87984 17.66C8.74984 17.69 8.61984 17.69 8.49984 17.69ZM16.5698 3.55L8.68984 11.43C8.49984 11.62 8.27984 12.06 8.23984 12.32L7.80984 15.33C7.76984 15.62 7.82984 15.86 7.97984 16.01C8.12984 16.16 8.36984 16.22 8.65984 16.18L11.6698 15.75C11.9298 15.71 12.3798 15.49 12.5598 15.3L20.4398 7.42C21.0898 6.77 21.4298 6.19 21.4798 5.65C21.5398 5 21.1998 4.31 20.4398 3.54C18.8398 1.94 17.7398 2.39 16.5698 3.55Z"
            fill="#232323"
          />
          <path
            d="M19.8501 9.83C19.7801 9.83 19.7101 9.82 19.6501 9.8C17.0201 9.06 14.9301 6.97 14.1901 4.34C14.0801 3.94 14.3101 3.53 14.7101 3.41C15.1101 3.3 15.5201 3.53 15.6301 3.93C16.2301 6.06 17.9201 7.75 20.0501 8.35C20.4501 8.46 20.6801 8.88 20.5701 9.28C20.4801 9.62 20.1801 9.83 19.8501 9.83Z"
            fill="#232323"
          />
        </svg>
      );
      break;
    case "reportedIssues":
      icon = (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M5.1499 22.75C4.7399 22.75 4.3999 22.41 4.3999 22V2C4.3999 1.59 4.7399 1.25 5.1499 1.25C5.5599 1.25 5.8999 1.59 5.8999 2V22C5.8999 22.41 5.5599 22.75 5.1499 22.75Z"
            fill="#232323"
          />
          <path
            d="M16.3499 16.75H5.1499C4.7399 16.75 4.3999 16.41 4.3999 16C4.3999 15.59 4.7399 15.25 5.1499 15.25H16.3499C17.4399 15.25 17.9499 14.96 18.0499 14.71C18.1499 14.46 17.9999 13.9 17.2199 13.13L16.0199 11.93C15.5299 11.5 15.2299 10.85 15.1999 10.13C15.1699 9.37 15.4699 8.62 16.0199 8.07L17.2199 6.87C17.9599 6.13 18.1899 5.53 18.0799 5.27C17.9699 5.01 17.3999 4.75 16.3499 4.75H5.1499C4.7299 4.75 4.3999 4.41 4.3999 4C4.3999 3.59 4.7399 3.25 5.1499 3.25H16.3499C18.5399 3.25 19.2399 4.16 19.4699 4.7C19.6899 5.24 19.8399 6.38 18.2799 7.94L17.0799 9.14C16.8299 9.39 16.6899 9.74 16.6999 10.09C16.7099 10.39 16.8299 10.66 17.0399 10.85L18.2799 12.08C19.8099 13.61 19.6599 14.75 19.4399 15.3C19.2099 15.83 18.4999 16.75 16.3499 16.75Z"
            fill="#232323"
          />
        </svg>
      );
      break;
    case "email":
      icon = (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M17 20.5H7C4 20.5 2 19 2 15.5V8.5C2 5 4 3.5 7 3.5H17C20 3.5 22 5 22 8.5V15.5C22 19 20 20.5 17 20.5Z"
            stroke="#232323"
            stroke-width="1.5"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M17 9L13.87 11.5C12.84 12.32 11.15 12.32 10.12 11.5L7 9"
            stroke="#232323"
            stroke-width="1.5"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      );
      break;
    case "call":
      icon = (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M21.97 18.33C21.97 18.69 21.89 19.06 21.72 19.42C21.55 19.78 21.33 20.12 21.04 20.44C20.55 20.98 20.01 21.37 19.4 21.62C18.8 21.87 18.15 22 17.45 22C16.43 22 15.34 21.76 14.19 21.27C13.04 20.78 11.89 20.12 10.75 19.29C9.6 18.45 8.51 17.52 7.47 16.49C6.44 15.45 5.51 14.36 4.68 13.22C3.86 12.08 3.2 10.94 2.72 9.81C2.24 8.67 2 7.58 2 6.54C2 5.86 2.12 5.21 2.36 4.61C2.6 4 2.98 3.44 3.51 2.94C4.15 2.31 4.85 2 5.59 2C5.87 2 6.15 2.06 6.4 2.18C6.66 2.3 6.89 2.48 7.07 2.74L9.39 6.01C9.57 6.26 9.7 6.49 9.79 6.71C9.88 6.92 9.93 7.13 9.93 7.32C9.93 7.56 9.86 7.8 9.72 8.03C9.59 8.26 9.4 8.5 9.16 8.74L8.4 9.53C8.29 9.64 8.24 9.77 8.24 9.93C8.24 10.01 8.25 10.08 8.27 10.16C8.3 10.24 8.33 10.3 8.35 10.36C8.53 10.69 8.84 11.12 9.28 11.64C9.73 12.16 10.21 12.69 10.73 13.22C11.27 13.75 11.79 14.24 12.32 14.69C12.84 15.13 13.27 15.43 13.61 15.61C13.66 15.63 13.72 15.66 13.79 15.69C13.87 15.72 13.95 15.73 14.04 15.73C14.21 15.73 14.34 15.67 14.45 15.56L15.21 14.81C15.46 14.56 15.7 14.37 15.93 14.25C16.16 14.11 16.39 14.04 16.64 14.04C16.83 14.04 17.03 14.08 17.25 14.17C17.47 14.26 17.7 14.39 17.95 14.56L21.26 16.91C21.52 17.09 21.7 17.3 21.81 17.55C21.91 17.8 21.97 18.05 21.97 18.33Z"
            stroke="#232323"
            stroke-width="1.5"
            stroke-miterlimit="10"
          />
          <path
            d="M18.5 9C18.5 8.4 18.03 7.48 17.33 6.73C16.69 6.04 15.84 5.5 15 5.5"
            stroke="#232323"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M22 9C22 5.13 18.87 2 15 2"
            stroke="#232323"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      );
      break;
    case "clock":
      icon = (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M22 12C22 17.52 17.52 22 12 22C6.48 22 2 17.52 2 12C2 6.48 6.48 2 12 2C17.52 2 22 6.48 22 12Z"
            stroke="#232323"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M15.7099 15.18L12.6099 13.33C12.0699 13.01 11.6299 12.24 11.6299 11.61V7.51"
            stroke="#232323"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      );
      break;
    case "calendar":
      icon = (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M8 1.25C8.41421 1.25 8.75 1.58579 8.75 2V5C8.75 5.41421 8.41421 5.75 8 5.75C7.58579 5.75 7.25 5.41421 7.25 5V2C7.25 1.58579 7.58579 1.25 8 1.25Z"
            fill="#232323"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M16 1.25C16.4142 1.25 16.75 1.58579 16.75 2V5C16.75 5.41421 16.4142 5.75 16 5.75C15.5858 5.75 15.25 5.41421 15.25 5V2C15.25 1.58579 15.5858 1.25 16 1.25Z"
            fill="#232323"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M2.75 9.09C2.75 8.67578 3.08579 8.34 3.5 8.34H20.5C20.9142 8.34 21.25 8.67578 21.25 9.09C21.25 9.50421 20.9142 9.84 20.5 9.84H3.5C3.08579 9.84 2.75 9.50421 2.75 9.09Z"
            fill="#232323"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M4.7371 5.38534C4.09637 6.07535 3.75 7.11497 3.75 8.5V17C3.75 18.385 4.09637 19.4246 4.7371 20.1147C5.36848 20.7946 6.39295 21.25 8 21.25H16C17.607 21.25 18.6315 20.7946 19.2629 20.1147C19.9036 19.4246 20.25 18.385 20.25 17V8.5C20.25 7.11497 19.9036 6.07535 19.2629 5.38534C18.6315 4.70538 17.607 4.25 16 4.25H8C6.39295 4.25 5.36848 4.70538 4.7371 5.38534ZM3.6379 4.36466C4.63152 3.29462 6.10705 2.75 8 2.75H16C17.893 2.75 19.3685 3.29462 20.3621 4.36466C21.3464 5.42465 21.75 6.88503 21.75 8.5V17C21.75 18.615 21.3464 20.0754 20.3621 21.1353C19.3685 22.2054 17.893 22.75 16 22.75H8C6.10705 22.75 4.63152 22.2054 3.6379 21.1353C2.65363 20.0754 2.25 18.615 2.25 17V8.5C2.25 6.88503 2.65363 5.42465 3.6379 4.36466Z"
            fill="#232323"
          />
        </svg>
      );
      break;
    case "upgrade":
      icon = (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M10.4902 2.22945L5.50016 4.10937C4.35016 4.53935 3.41016 5.89929 3.41016 7.11923V14.5489C3.41016 15.7288 4.19016 17.2788 5.14016 17.9887L9.44016 21.1986C10.8502 22.2586 13.1702 22.2586 14.5802 21.1986L18.8802 17.9887C19.8302 17.2788 20.6102 15.7288 20.6102 14.5489V7.11923C20.6102 5.88929 19.6702 4.52935 18.5202 4.09937L13.5302 2.22945C12.6802 1.91947 11.3202 1.91947 10.4902 2.22945Z"
            stroke="#232323"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M9.0498 11.8685L10.6598 13.4784L14.9598 9.1786"
            stroke="#232323"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      );
      break;
    case "offer":
      icon = (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M3.9889 14.6604L2.46891 13.1404C1.84891 12.5204 1.84891 11.5004 2.46891 10.8804L3.9889 9.36039C4.2489 9.10039 4.4589 8.59038 4.4589 8.23038V6.08036C4.4589 5.20036 5.1789 4.48038 6.0589 4.48038H8.2089C8.5689 4.48038 9.0789 4.27041 9.3389 4.01041L10.8589 2.49039C11.4789 1.87039 12.4989 1.87039 13.1189 2.49039L14.6389 4.01041C14.8989 4.27041 15.4089 4.48038 15.7689 4.48038H17.9189C18.7989 4.48038 19.5189 5.20036 19.5189 6.08036V8.23038C19.5189 8.59038 19.7289 9.10039 19.9889 9.36039L21.5089 10.8804C22.1289 11.5004 22.1289 12.5204 21.5089 13.1404L19.9889 14.6604C19.7289 14.9204 19.5189 15.4304 19.5189 15.7904V17.9403C19.5189 18.8203 18.7989 19.5404 17.9189 19.5404H15.7689C15.4089 19.5404 14.8989 19.7504 14.6389 20.0104L13.1189 21.5304C12.4989 22.1504 11.4789 22.1504 10.8589 21.5304L9.3389 20.0104C9.0789 19.7504 8.5689 19.5404 8.2089 19.5404H6.0589C5.1789 19.5404 4.4589 18.8203 4.4589 17.9403V15.7904C4.4589 15.4204 4.2489 14.9104 3.9889 14.6604Z"
            stroke="#232323"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M9 15L15 9"
            stroke="#232323"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M14.4945 14.5H14.5035"
            stroke="#232323"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M9.49451 9.5H9.50349"
            stroke="#232323"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      );
      break;
    case "team":
      icon = (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M9.16006 10.87C9.06006 10.86 8.94006 10.86 8.83006 10.87C6.45006 10.79 4.56006 8.84 4.56006 6.44C4.56006 3.99 6.54006 2 9.00006 2C11.4501 2 13.4401 3.99 13.4401 6.44C13.4301 8.84 11.5401 10.79 9.16006 10.87Z"
            stroke="#232323"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M16.4098 4C18.3498 4 19.9098 5.57 19.9098 7.5C19.9098 9.39 18.4098 10.93 16.5398 11C16.4598 10.99 16.3698 10.99 16.2798 11"
            stroke="#232323"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M4.16021 14.56C1.74021 16.18 1.74021 18.82 4.16021 20.43C6.91021 22.27 11.4202 22.27 14.1702 20.43C16.5902 18.81 16.5902 16.17 14.1702 14.56C11.4302 12.73 6.92021 12.73 4.16021 14.56Z"
            stroke="#232323"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M18.3398 20C19.0598 19.85 19.7398 19.56 20.2998 19.13C21.8598 17.96 21.8598 16.03 20.2998 14.86C19.7498 14.44 19.0798 14.16 18.3698 14"
            stroke="#232323"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      );
      break;
    case "like":
      icon = (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0_2318_20104)">
            <path
              d="M7.47998 18.35L10.58 20.75C10.98 21.15 11.88 21.35 12.48 21.35H16.28C17.48 21.35 18.78 20.45 19.08 19.25L21.48 11.95C21.98 10.55 21.08 9.35 19.58 9.35H15.58C14.98 9.35 14.48 8.85 14.58 8.15L15.08 4.95C15.28 4.05 14.68 3.05 13.78 2.75C12.98 2.45 11.98 2.85 11.58 3.45L7.47998 9.55"
              stroke="#232323"
              stroke-width="1.5"
              stroke-miterlimit="10"
            />
            <path
              d="M2.37988 18.35V8.55C2.37988 7.15 2.97988 6.65 4.37988 6.65H5.37988C6.77988 6.65 7.37988 7.15 7.37988 8.55V18.35C7.37988 19.75 6.77988 20.25 5.37988 20.25H4.37988C2.97988 20.25 2.37988 19.75 2.37988 18.35Z"
              stroke="#232323"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </g>
          <defs>
            <clipPath id="clip0_2318_20104">
              <rect width="24" height="24" fill="white" />
            </clipPath>
          </defs>
        </svg>
      );
      break;
    case "filter":
      icon = (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M5.3999 2.1H18.5999C19.6999 2.1 20.5999 3 20.5999 4.1V6.3C20.5999 7.1 20.0999 8.1 19.5999 8.6L15.2999 12.4C14.6999 12.9 14.2999 13.9 14.2999 14.7V19C14.2999 19.6 13.8999 20.4 13.3999 20.7L11.9999 21.6C10.6999 22.4 8.8999 21.5 8.8999 19.9V14.6C8.8999 13.9 8.4999 13 8.0999 12.5L4.2999 8.5C3.7999 8 3.3999 7.1 3.3999 6.5V4.2C3.3999 3 4.2999 2.1 5.3999 2.1Z"
            stroke="#232323"
            stroke-width="1.5"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      );
      break;
    case "link":
      icon = (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M9 22H15C20 22 22 20 22 15V9C22 4 20 2 15 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22Z"
            stroke="#232323"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M9.33789 8H16.3197V14.9982"
            stroke="#232323"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M16.32 8L7 17.32"
            stroke="#232323"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      );
      break;
    case "camera":
      icon = (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0_2809_32593)">
            <path
              d="M6.64072 22H16.8437C19.5307 22 20.6016 20.31 20.7282 18.25L21.2344 9.99C21.3707 7.83 19.6962 6 17.5836 6C16.9897 6 16.4445 5.65 16.1719 5.11L15.4709 3.66C15.0231 2.75 13.8548 2 12.8618 2H10.6323C9.62956 2 8.46128 2.75 8.01344 3.66L7.31248 5.11C7.03988 5.65 6.49469 6 5.90081 6C3.78818 6 2.11366 7.83 2.24996 9.99L2.75621 18.25C2.87304 20.31 3.95369 22 6.64072 22Z"
              stroke="#292D32"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M10.5 8H13.5"
              stroke="#292D32"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M12 18C13.79 18 15.25 16.54 15.25 14.75C15.25 12.96 13.79 11.5 12 11.5C10.21 11.5 8.75 12.96 8.75 14.75C8.75 16.54 10.21 18 12 18Z"
              stroke="#292D32"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </g>
          <defs>
            <clipPath id="clip0_2809_32593">
              <rect width="24" height="24" fill="white" />
            </clipPath>
          </defs>
        </svg>
      );
      break;
    case "key":
      icon = (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0_2809_32833)">
            <path
              d="M19.7901 14.93C17.7301 16.98 14.7801 17.61 12.1901 16.8L7.48015 21.5C7.14015 21.85 6.47015 22.06 5.99015 21.99L3.81015 21.69C3.09015 21.59 2.42015 20.91 2.31015 20.19L2.01015 18.01C1.94015 17.53 2.17015 16.86 2.50015 16.52L7.20015 11.82C6.40015 9.22 7.02015 6.27 9.08015 4.22C12.0301 1.27 16.8201 1.27 19.7801 4.22C22.7401 7.17 22.7401 11.98 19.7901 14.93Z"
              stroke="#292D32"
              stroke-width="1.5"
              stroke-miterlimit="10"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M6.89014 17.49L9.19014 19.79"
              stroke="#292D32"
              stroke-width="1.5"
              stroke-miterlimit="10"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M14.5 11C15.3284 11 16 10.3284 16 9.5C16 8.67157 15.3284 8 14.5 8C13.6716 8 13 8.67157 13 9.5C13 10.3284 13.6716 11 14.5 11Z"
              stroke="#292D32"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </g>
          <defs>
            <clipPath id="clip0_2809_32833">
              <rect width="24" height="24" fill="white" />
            </clipPath>
          </defs>
        </svg>
      );
      break;
    case "support":
      icon = (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0_2809_32890)">
            <path
              d="M18 18.86H17.24C16.44 18.86 15.68 19.17 15.12 19.73L13.41 21.42C12.63 22.19 11.36 22.19 10.58 21.42L8.87 19.73C8.31 19.17 7.54 18.86 6.75 18.86H6C4.34 18.86 3 17.53 3 15.89V4.97998C3 3.33998 4.34 2.01001 6 2.01001H18C19.66 2.01001 21 3.33998 21 4.97998V15.89C21 17.52 19.66 18.86 18 18.86Z"
              stroke="#292D32"
              stroke-width="1.5"
              stroke-miterlimit="10"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M7 9.16003C7 8.23003 7.76 7.46997 8.69 7.46997C9.62 7.46997 10.38 8.23003 10.38 9.16003C10.38 11.04 7.71 11.24 7.12 13.03C7 13.4 7.31 13.77 7.7 13.77H10.38"
              stroke="#292D32"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M16.0398 13.76V8.05003C16.0398 7.79003 15.8698 7.55997 15.6198 7.48997C15.3698 7.41997 15.0998 7.51997 14.9598 7.73997C14.2398 8.89997 13.4598 10.22 12.7798 11.38C12.6698 11.57 12.6698 11.82 12.7798 12.01C12.8898 12.2 13.0998 12.3199 13.3298 12.3199H16.9998"
              stroke="#292D32"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </g>
          <defs>
            <clipPath id="clip0_2809_32890">
              <rect width="24" height="24" fill="white" />
            </clipPath>
          </defs>
        </svg>
      );
      break;
    case "sequence":
      icon = (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0_3077_29970)">
            <path
              d="M20 6.95V17.05C19.84 17.02 19.67 17 19.5 17C18.12 17 17 18.12 17 19.5C17 19.67 17.02 19.84 17.05 20H6.95C6.98 19.84 7 19.67 7 19.5C7 18.12 5.88 17 4.5 17C4.33 17 4.16 17.02 4 17.05V6.95C4.16 6.98 4.33 7 4.5 7C5.88 7 7 5.88 7 4.5C7 4.33 6.98 4.16 6.95 4H17.05C17.02 4.16 17 4.33 17 4.5C17 5.88 18.12 7 19.5 7C19.67 7 19.84 6.98 20 6.95Z"
              stroke="#292D32"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M7 4.5C7 5.88 5.88 7 4.5 7C4.33 7 4.16 6.98 4 6.95C2.86 6.72 2 5.71 2 4.5C2 3.12 3.12 2 4.5 2C5.71 2 6.72 2.86 6.95 4C6.98 4.16 7 4.33 7 4.5Z"
              stroke="#292D32"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M22 4.5C22 5.71 21.14 6.72 20 6.95C19.84 6.98 19.67 7 19.5 7C18.12 7 17 5.88 17 4.5C17 4.33 17.02 4.16 17.05 4C17.28 2.86 18.29 2 19.5 2C20.88 2 22 3.12 22 4.5Z"
              stroke="#292D32"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M7 19.5C7 19.67 6.98 19.84 6.95 20C6.72 21.14 5.71 22 4.5 22C3.12 22 2 20.88 2 19.5C2 18.29 2.86 17.28 4 17.05C4.16 17.02 4.33 17 4.5 17C5.88 17 7 18.12 7 19.5Z"
              stroke="#292D32"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M22 19.5C22 20.88 20.88 22 19.5 22C18.29 22 17.28 21.14 17.05 20C17.02 19.84 17 19.67 17 19.5C17 18.12 18.12 17 19.5 17C19.67 17 19.84 17.02 20 17.05C21.14 17.28 22 18.29 22 19.5Z"
              stroke="#292D32"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </g>
          <defs>
            <clipPath id="clip0_3077_29970">
              <rect width="24" height="24" fill="white" />
            </clipPath>
          </defs>
        </svg>
      );
      break;
    case "joiningDate":
      icon = (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0_3077_29987)">
            <path
              d="M8 2V5"
              stroke="#292D32"
              stroke-width="1.5"
              stroke-miterlimit="10"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M16 2V5"
              stroke="#292D32"
              stroke-width="1.5"
              stroke-miterlimit="10"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M3.5 9.09H20.5"
              stroke="#292D32"
              stroke-width="1.5"
              stroke-miterlimit="10"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M22 19C22 19.75 21.79 20.46 21.42 21.06C20.73 22.22 19.46 23 18 23C16.99 23 16.07 22.63 15.37 22C15.06 21.74 14.79 21.42 14.58 21.06C14.21 20.46 14 19.75 14 19C14 16.79 15.79 15 18 15C19.2 15 20.27 15.53 21 16.36C21.62 17.07 22 17.99 22 19Z"
              stroke="#292D32"
              stroke-width="1.5"
              stroke-miterlimit="10"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M16.4399 19L17.4299 19.99L19.5599 18.02"
              stroke="#292D32"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M21 8.5V16.36C20.27 15.53 19.2 15 18 15C15.79 15 14 16.79 14 19C14 19.75 14.21 20.46 14.58 21.06C14.79 21.42 15.06 21.74 15.37 22H8C4.5 22 3 20 3 17V8.5C3 5.5 4.5 3.5 8 3.5H16C19.5 3.5 21 5.5 21 8.5Z"
              stroke="#292D32"
              stroke-width="1.5"
              stroke-miterlimit="10"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M11.9955 13.7H12.0045"
              stroke="#292D32"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M8.29431 13.7H8.30329"
              stroke="#292D32"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M8.29431 16.7H8.30329"
              stroke="#292D32"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </g>
          <defs>
            <clipPath id="clip0_3077_29987">
              <rect width="24" height="24" fill="white" />
            </clipPath>
          </defs>
        </svg>
      );
      break;
    case "role":
      icon = (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0_3082_30919)">
            <path
              d="M18 18.86H17.24C16.44 18.86 15.68 19.17 15.12 19.73L13.41 21.42C12.63 22.19 11.36 22.19 10.58 21.42L8.87 19.73C8.31 19.17 7.54 18.86 6.75 18.86H6C4.34 18.86 3 17.53 3 15.89V4.97C3 3.33 4.34 2 6 2H18C19.66 2 21 3.33 21 4.97V15.88C21 17.52 19.66 18.86 18 18.86Z"
              stroke="#292D32"
              stroke-width="1.5"
              stroke-miterlimit="10"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M12.0701 8.95C12.0301 8.95 11.97 8.95 11.92 8.95C10.87 8.91 10.04 8.06 10.04 7C10.04 5.92 10.9101 5.05 11.9901 5.05C13.0701 5.05 13.9401 5.93 13.9401 7C13.9501 8.06 13.1201 8.92 12.0701 8.95Z"
              stroke="#292D32"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M9.24994 11.96C7.91994 12.85 7.91994 14.3 9.24994 15.19C10.7599 16.2 13.2399 16.2 14.7499 15.19C16.0799 14.3 16.0799 12.85 14.7499 11.96C13.2399 10.96 10.7699 10.96 9.24994 11.96Z"
              stroke="#292D32"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </g>
          <defs>
            <clipPath id="clip0_3082_30919">
              <rect width="24" height="24" fill="white" />
            </clipPath>
          </defs>
        </svg>
      );
      break;
    case "status":
      icon = (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0_3082_31004)">
            <path
              d="M9.31006 14.7L10.8101 16.2L14.8101 12.2"
              stroke="#292D32"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M10 6H14C16 6 16 5 16 4C16 2 15 2 14 2H10C9 2 8 2 8 4C8 6 9 6 10 6Z"
              stroke="#292D32"
              stroke-width="1.5"
              stroke-miterlimit="10"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M16 4.02C19.33 4.2 21 5.43 21 10V16C21 20 20 22 15 22H9C4 22 3 20 3 16V10C3 5.44 4.67 4.2 8 4.02"
              stroke="#292D32"
              stroke-width="1.5"
              stroke-miterlimit="10"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </g>
          <defs>
            <clipPath id="clip0_3082_31004">
              <rect width="24" height="24" fill="white" />
            </clipPath>
          </defs>
        </svg>
      );
      break;
    case "filterLines":
      icon = (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M20.2503 6C20.6645 6 21.0003 6.33579 21.0003 6.75C21.0003 7.16421 20.6645 7.5 20.2503 7.5H3.74994C3.33572 7.5 2.99994 7.16421 2.99994 6.75C2.99994 6.33579 3.33572 6 3.74994 6H20.2503ZM21.0003 11.036C21.0003 10.6218 20.6645 10.286 20.2503 10.286H3.74994C3.33572 10.286 2.99994 10.6218 2.99994 11.036C2.99994 11.4502 3.33572 11.786 3.74994 11.786H20.2503C20.6645 11.786 21.0003 11.4502 21.0003 11.036ZM21.0003 15.322C21.0003 14.9078 20.6645 14.572 20.2503 14.572H3.74994C3.33572 14.572 2.99994 14.9078 2.99994 15.322C2.99994 15.7362 3.33572 16.072 3.74994 16.072H20.2503C20.6645 16.072 21.0003 15.7362 21.0003 15.322Z"
            fill="#232323"
          />
        </svg>
      );
      break;
    case "delete":
      icon = (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M21 5.97998C17.67 5.64998 14.32 5.47998 10.98 5.47998C9 5.47998 7.02 5.57998 5.04 5.77998L3 5.97998"
            stroke="#232323"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M8.5 4.97006L8.72 3.66006C8.88 2.71006 9 2.00006 10.69 2.00006H13.31C15 2.00006 15.13 2.75006 15.28 3.67006L15.5 4.97006"
            stroke="#232323"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M18.8494 9.14008L18.1994 19.2101C18.0894 20.7801 17.9994 22.0001 15.2094 22.0001H8.78941C5.99941 22.0001 5.90941 20.7801 5.79941 19.2101L5.14941 9.14008"
            stroke="#232323"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M10.3301 16.5H13.6601"
            stroke="#232323"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M9.5 12.5001H14.5"
            stroke="#232323"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      );
      break;
    case "growArrow":
      icon = (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M4 20L20 4"
            stroke="#232323"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M19.9999 12.5868V4H11.4131"
            stroke="#232323"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      );
      break;
    case "edit":
      icon = (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M13.2603 3.59988L5.05034 12.2899C4.74034 12.6199 4.44034 13.2699 4.38034 13.7199L4.01034 16.9599C3.88034 18.1299 4.72034 18.9299 5.88034 18.7299L9.10034 18.1799C9.55034 18.0999 10.1803 17.7699 10.4903 17.4299L18.7003 8.73988C20.1203 7.23988 20.7603 5.52988 18.5503 3.43988C16.3503 1.36988 14.6803 2.09988 13.2603 3.59988Z"
            stroke="#232323"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M11.8901 5.05013C12.3201 7.81013 14.5601 9.92012 17.3401 10.2001"
            stroke="#232323"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M3 22H21"
            stroke="#232323"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      );
      break;
    case "archive":
      icon = (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M22 10V15C22 20 20 22 15 22H9C4 22 2 20 2 15V9C2 4 4 2 9 2H14"
            stroke="#232323"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M22 10H18C15 10 14 9 14 6V2L22 10Z"
            stroke="#232323"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M7 13H13"
            stroke="#232323"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M7 17H11"
            stroke="#232323"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      );
      break;
    case "duplicate":
      icon = (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M16 12.9V17.1C16 20.6 14.6 22 11.1 22H6.9C3.4 22 2 20.6 2 17.1V12.9C2 9.4 3.4 8 6.9 8H11.1C14.6 8 16 9.4 16 12.9Z"
            stroke="#232323"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M22 6.9V11.1C22 14.6 20.6 16 17.1 16H16V12.9C16 9.4 14.6 8 11.1 8H8V6.9C8 3.4 9.4 2 12.9 2H17.1C20.6 2 22 3.4 22 6.9Z"
            stroke="#232323"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      );
      break;
    case "createDate":
      icon = (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0_2144_19054)">
            <path
              d="M9.56006 18V13"
              stroke="#232323"
              stroke-miterlimit="10"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M12 15.5H7"
              stroke="#232323"
              stroke-miterlimit="10"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M8 2V5"
              stroke="#232323"
              stroke-miterlimit="10"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M16 2V5"
              stroke="#232323"
              stroke-miterlimit="10"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M15.8098 3.42C19.1498 3.54 20.8398 4.77 20.9398 9.47L21.0698 15.64C21.1498 19.76 20.1998 21.83 15.1998 21.94L9.19983 22.06C4.19983 22.16 3.15983 20.12 3.07983 16.01L2.93983 9.83C2.83983 5.13 4.48983 3.83 7.80983 3.58L15.8098 3.42Z"
              stroke="#232323"
              stroke-miterlimit="10"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </g>
          <defs>
            <clipPath id="clip0_2144_19054">
              <rect width="24" height="24" fill="white" />
            </clipPath>
          </defs>
        </svg>
      );
      break;
    case "action":
      icon = (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M1.99609 8.5H11.4961"
            stroke="#232323"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M5.99609 16.5H7.99609"
            stroke="#232323"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M10.4961 16.5H14.4961"
            stroke="#232323"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M21.9961 12.03V16.11C21.9961 19.62 21.1061 20.5 17.5561 20.5H6.43609C2.88609 20.5 1.99609 19.62 1.99609 16.11V7.89C1.99609 4.38 2.88609 3.5 6.43609 3.5H14.4961"
            stroke="#232323"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M19.0764 4.13L15.3664 7.84C15.2264 7.98 15.0864 8.26 15.0564 8.46L14.8564 9.88C14.7864 10.39 15.1464 10.75 15.6564 10.68L17.0764 10.48C17.2764 10.45 17.5564 10.31 17.6964 10.17L21.4064 6.46C22.0464 5.82 22.3464 5.08 21.4064 4.14C20.4564 3.19 19.7164 3.49 19.0764 4.13Z"
            stroke="#232323"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M18.5459 4.66C18.8659 5.79 19.7459 6.67 20.8659 6.98"
            stroke="#232323"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      );
      break;
    case "exit":
      icon = (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M8.8999 7.56001C9.2099 3.96001 11.0599 2.49001 15.1099 2.49001H15.2399C19.7099 2.49001 21.4999 4.28001 21.4999 8.75001V15.27C21.4999 19.74 19.7099 21.53 15.2399 21.53H15.1099C11.0899 21.53 9.2399 20.08 8.9099 16.54"
            stroke="#232323"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M2 12H14.88"
            stroke="#232323"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M12.6499 8.64999L15.9999 12L12.6499 15.35"
            stroke="#232323"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      );
      break;
    case "skip":
      icon = (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M3.75977 7.21999V16.79C3.75977 18.75 5.88975 19.98 7.58975 19L11.7397 16.61L15.8898 14.21C17.5898 13.23 17.5898 10.78 15.8898 9.79998L11.7397 7.39998L7.58975 5.01C5.88975 4.03 3.75977 5.24999 3.75977 7.21999Z"
            stroke="#232323"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M20.2402 18.18V5.82001"
            stroke="#232323"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      );
      break;
    case "google":
      icon = (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0_1840_13592)">
            <path
              d="M5.31891 14.5035L4.4835 17.6222L1.43011 17.6868C0.517594 15.9943 0 14.0578 0 12C0 10.0101 0.483938 8.13362 1.34175 6.48132H1.34241L4.06078 6.9797L5.25159 9.68176C5.00236 10.4084 4.86652 11.1884 4.86652 12C4.86661 12.8809 5.02617 13.7249 5.31891 14.5035Z"
              fill="#FBBB00"
            />
            <path
              d="M23.7902 9.75824C23.928 10.4841 23.9999 11.2338 23.9999 12C23.9999 12.8591 23.9095 13.6971 23.7374 14.5055C23.1533 17.2563 21.6269 19.6582 19.5124 21.358L19.5118 21.3574L16.0878 21.1827L15.6032 18.1576C17.0063 17.3347 18.1028 16.047 18.6804 14.5055H12.2637V9.75824H18.774H23.7902Z"
              fill="#518EF8"
            />
            <path
              d="M19.5119 21.3574L19.5126 21.358C17.4561 23.011 14.8438 24 12.0001 24C7.43018 24 3.457 21.4457 1.43018 17.6868L5.31897 14.5035C6.33236 17.2081 8.94138 19.1334 12.0001 19.1334C13.3148 19.1334 14.5465 18.778 15.6033 18.1576L19.5119 21.3574Z"
              fill="#28B446"
            />
            <path
              d="M19.6594 2.76263L15.772 5.94525C14.6781 5.26153 13.3851 4.86656 11.9999 4.86656C8.87196 4.86656 6.21414 6.88017 5.25152 9.68175L1.34229 6.48131C3.33944 2.63077 7.36207 0 11.9999 0C14.9115 0 17.5812 1.03716 19.6594 2.76263Z"
              fill="#F14336"
            />
          </g>
          <defs>
            <clipPath id="clip0_1840_13592">
              <rect width="24" height="24" fill="white" />
            </clipPath>
          </defs>
        </svg>
      );
      break;
    case "microsoft":
      icon = (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0_1840_13593)">
            <path
              d="M12.75 11.25H24V0.75C24 0.336 23.664 0 23.25 0H12.75V11.25Z"
              fill="#4CAF50"
            />
            <path
              d="M11.25 11.25V0H0.75C0.336 0 0 0.336 0 0.75V11.25H11.25Z"
              fill="#F44336"
            />
            <path
              d="M11.25 12.75H0V23.25C0 23.664 0.336 24 0.75 24H11.25V12.75Z"
              fill="#2196F3"
            />
            <path
              d="M12.75 12.75V24H23.25C23.664 24 24 23.664 24 23.25V12.75H12.75Z"
              fill="#FFC107"
            />
          </g>
          <defs>
            <clipPath id="clip0_1840_13593">
              <rect width="24" height="24" fill="white" />
            </clipPath>
          </defs>
        </svg>
      );
      break;
    case "linkedIn":
      icon = (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0_1840_13594)">
            <path
              d="M24.0003 23.9777C23.8679 23.9777 23.7355 23.9943 23.6031 23.9943C22.0961 23.9943 20.5892 23.9943 19.0796 23.9943C18.8942 23.9943 18.8465 23.9417 18.8465 23.7477C18.8465 20.8459 18.8465 17.9449 18.8465 15.0449C18.8423 14.571 18.7791 14.0997 18.6585 13.6429C18.5605 13.2134 18.3605 12.8167 18.0769 12.4896C17.7934 12.1624 17.4355 11.9154 17.0365 11.7715C16.6375 11.6276 16.2101 11.5913 15.7942 11.6661C15.3782 11.7409 14.9869 11.9243 14.6567 12.1994C14.2765 12.4762 13.9675 12.8468 13.7568 13.2783C13.5462 13.7099 13.4405 14.1891 13.449 14.6736C13.449 17.666 13.449 20.6575 13.449 23.648C13.449 24.0359 13.502 23.9888 13.1286 23.9888C11.5978 23.9888 10.067 23.9888 8.53621 23.9888C8.33493 23.9888 8.29785 23.9306 8.29785 23.7311C8.29785 18.5 8.29785 13.2689 8.29785 8.03775C8.29785 7.83548 8.34552 7.78284 8.53886 7.78561C10.0935 7.78561 11.6481 7.78561 13.2027 7.78561C13.4252 7.78561 13.4676 7.86042 13.4676 8.06268C13.4543 8.70826 13.4676 9.35384 13.4676 10.0022C13.5629 9.98556 13.5788 9.90244 13.6132 9.84979C14.7468 8.0987 16.3491 7.35615 18.3407 7.41987C19.6165 7.42191 20.8535 7.87935 21.8472 8.71657C22.9224 9.6503 23.4865 10.8916 23.7885 12.288C23.8838 12.7257 23.9475 13.1703 23.9792 13.618C23.9792 13.6568 23.9792 13.7011 24.0242 13.7177L24.0003 23.9777Z"
              fill="#2768B2"
            />
            <path
              d="M0 2.30097C0.0794526 2.26218 0.060916 2.17352 0.0768065 2.10979C0.208625 1.56822 0.493901 1.08101 0.895184 0.71213C1.29647 0.343248 1.79499 0.109942 2.32531 0.0428372C3.03878 -0.086508 3.77309 0.0271179 4.42022 0.367007C4.89721 0.639643 5.28186 1.06006 5.52133 1.57055C5.7608 2.08103 5.84335 2.65655 5.75767 3.21808C5.68459 3.76406 5.4536 4.27357 5.09569 4.67822C4.73779 5.08286 4.27011 5.36326 3.75546 5.48177C2.79674 5.70897 1.87508 5.63415 1.04878 5.01351C0.566747 4.65441 0.225251 4.12491 0.0873984 3.52286C0.066211 3.44251 0.0873979 3.34276 0 3.28458V2.30097Z"
              fill="#2768B2"
            />
            <path
              d="M0.301758 15.9119C0.301758 13.2964 0.301758 10.6817 0.301758 8.06803C0.301758 7.85468 0.344133 7.79095 0.5666 7.79095C2.12211 7.80204 3.67673 7.80204 5.23048 7.79095C5.41322 7.79095 5.46354 7.83528 5.46354 8.03201C5.46354 13.2687 5.46354 18.5072 5.46354 23.7475C5.46354 23.9304 5.4291 23.9941 5.23577 23.9941C3.6732 23.9941 2.11328 23.9941 0.55071 23.9941C0.341485 23.9941 0.312354 23.9193 0.312354 23.7171C0.307057 21.12 0.303523 18.5183 0.301758 15.9119Z"
              fill="#2768B2"
            />
          </g>
          <defs>
            <clipPath id="clip0_1840_13594">
              <rect width="24" height="24" fill="white" />
            </clipPath>
          </defs>
        </svg>
      );
      break;
    case "show":
      icon = (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M11.9999 9.17001C10.4341 9.17001 9.16992 10.4342 9.16992 12C9.16992 13.5658 10.4341 14.83 11.9999 14.83C13.5657 14.83 14.8299 13.5658 14.8299 12C14.8299 10.4342 13.5657 9.17001 11.9999 9.17001ZM7.66992 12C7.66992 9.6058 9.60571 7.67001 11.9999 7.67001C14.3941 7.67001 16.3299 9.6058 16.3299 12C16.3299 14.3942 14.3941 16.33 11.9999 16.33C9.60571 16.33 7.66992 14.3942 7.66992 12Z"
            fill="#232323"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M2.25734 8.99687C4.64825 5.23851 8.15186 2.96991 11.9998 2.96991C15.848 2.96991 19.3517 5.23871 21.7427 8.99737C22.2876 9.85171 22.5348 10.9461 22.5348 11.9949C22.5348 13.044 22.2875 14.1385 21.7423 14.9929C19.3514 18.7513 15.8478 21.0199 11.9998 21.0199C8.1517 21.0199 4.64795 18.7511 2.25703 14.9925L2.88984 14.5899L2.25765 14.9934C1.71224 14.139 1.46484 13.0442 1.46484 11.9949C1.46484 10.9459 1.71214 9.85129 2.25734 8.99687ZM11.9998 4.46991C8.78799 4.46991 5.71174 6.36111 3.52266 9.80245L3.52204 9.80344C3.16745 10.359 2.96484 11.1542 2.96484 11.9949C2.96484 12.8357 3.16745 13.6309 3.52204 14.1864L3.52266 14.1874C5.71174 17.6287 8.78799 19.5199 11.9998 19.5199C15.2117 19.5199 18.2879 17.6287 20.477 14.1874L20.4777 14.1864C20.8322 13.6309 21.0348 12.8357 21.0348 11.9949C21.0348 11.1542 20.8322 10.359 20.4777 9.80344L20.477 9.80245C18.2879 6.36111 15.2117 4.46991 11.9998 4.46991Z"
            fill="#232323"
          />
        </svg>
      );
      break;
    case "hide":
      icon = (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M14.5299 9.46998L9.46992 14.53C8.81992 13.88 8.41992 12.99 8.41992 12C8.41992 10.02 10.0199 8.41998 11.9999 8.41998C12.9899 8.41998 13.8799 8.81998 14.5299 9.46998Z"
            stroke="#232323"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M17.8198 5.76998C16.0698 4.44998 14.0698 3.72998 11.9998 3.72998C8.46984 3.72998 5.17984 5.80998 2.88984 9.40998C1.98984 10.82 1.98984 13.19 2.88984 14.6C3.67984 15.84 4.59984 16.91 5.59984 17.77"
            stroke="#232323"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M8.41992 19.53C9.55992 20.01 10.7699 20.27 11.9999 20.27C15.5299 20.27 18.8199 18.19 21.1099 14.59C22.0099 13.18 22.0099 10.81 21.1099 9.39999C20.7799 8.87999 20.4199 8.38999 20.0499 7.92999"
            stroke="#232323"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M15.5099 12.7C15.2499 14.11 14.0999 15.26 12.6899 15.52"
            stroke="#232323"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M9.47 14.53L2 22"
            stroke="#232323"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M21.9998 2L14.5298 9.47"
            stroke="#232323"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      );
      break;
    case "empty-content":
      icon = (
        <svg
          width="64"
          height="64"
          viewBox="0 0 64 64"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M58.6396 16.0532C58.693 16.6932 58.6396 17.3598 58.4796 18.0265L49.493 54.1064C48.853 56.7998 46.453 58.6665 43.6797 58.6665H8.63963C4.61296 58.6665 1.75967 54.7198 2.93301 50.8532L14.1596 14.7731C14.933 12.2664 17.253 10.5599 19.8664 10.5599H52.6663C55.2263 10.5599 57.3063 12.0799 58.1863 14.2132C58.453 14.7732 58.5863 15.4132 58.6396 16.0532Z"
            fill="#EFEFEF"
          />
          <path
            d="M61.3063 52.32C61.573 55.76 58.853 58.6667 55.413 58.6667H43.6797C46.453 58.6667 48.853 56.7999 49.493 54.1066L58.4797 18.0267C58.6397 17.36 58.693 16.6934 58.6396 16.0534L58.6663 16L61.3063 52.32Z"
            fill="#D9D9D9"
          />
          <path
            d="M25.813 19.0134C25.653 19.0134 25.4931 18.9867 25.3331 18.96C24.2664 18.6933 23.5998 17.6268 23.8664 16.5334L26.6397 5.0134C26.9064 3.94673 27.973 3.30677 29.0664 3.54677C30.133 3.81343 30.7998 4.88003 30.5331 5.97336L27.7597 17.4934C27.5464 18.4 26.7197 19.0134 25.813 19.0134Z"
            fill="#D9D9D9"
          />
          <path
            d="M43.6798 19.0401C43.5465 19.0401 43.3865 19.0401 43.2532 18.9868C42.1865 18.7468 41.4932 17.6801 41.7065 16.6134L44.2131 5.04014C44.4531 3.94681 45.5198 3.2801 46.5865 3.49343C47.6532 3.73343 48.3465 4.80014 48.1331 5.8668L45.6265 17.44C45.4398 18.4 44.6132 19.0401 43.6798 19.0401Z"
            fill="#D9D9D9"
          />
          <path
            d="M41.8665 34H20.5332C19.4399 34 18.5332 33.0933 18.5332 32C18.5332 30.9067 19.4399 30 20.5332 30H41.8665C42.9599 30 43.8665 30.9067 43.8665 32C43.8665 33.0933 42.9599 34 41.8665 34Z"
            fill="#D9D9D9"
          />
          <path
            d="M39.2 44.6667H17.8667C16.7734 44.6667 15.8667 43.76 15.8667 42.6667C15.8667 41.5734 16.7734 40.6667 17.8667 40.6667H39.2C40.2934 40.6667 41.2 41.5734 41.2 42.6667C41.2 43.76 40.2934 44.6667 39.2 44.6667Z"
            fill="#D9D9D9"
          />
        </svg>
      );
      break;
    case "property1-default":
      icon = (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M22 10.9V4.1C22 2.6 21.36 2 19.77 2H15.73C14.14 2 13.5 2.6 13.5 4.1V10.9C13.5 12.4 14.14 13 15.73 13H19.77C21.36 13 22 12.4 22 10.9Z"
            stroke={color ? color : "#232323"}
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M22 19.9V18.1C22 16.6 21.36 16 19.77 16H15.73C14.14 16 13.5 16.6 13.5 18.1V19.9C13.5 21.4 14.14 22 15.73 22H19.77C21.36 22 22 21.4 22 19.9Z"
            stroke={color ? color : "#232323"}
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M10.5 13.1V19.9C10.5 21.4 9.86 22 8.27 22H4.23C2.64 22 2 21.4 2 19.9V13.1C2 11.6 2.64 11 4.23 11H8.27C9.86 11 10.5 11.6 10.5 13.1Z"
            stroke={color ? color : "#232323"}
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M10.5 4.1V5.9C10.5 7.4 9.86 8 8.27 8H4.23C2.64 8 2 7.4 2 5.9V4.1C2 2.6 2.64 2 4.23 2H8.27C9.86 2 10.5 2.6 10.5 4.1Z"
            stroke={color ? color : "#232323"}
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      );
      break;
    case "property1-active":
      icon = (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M22 10.9V4.1C22 2.6 21.36 2 19.77 2H15.73C14.14 2 13.5 2.6 13.5 4.1V10.9C13.5 12.4 14.14 13 15.73 13H19.77C21.36 13 22 12.4 22 10.9Z"
            fill="#F15845"
          />
          <path
            d="M22 19.9V18.1C22 16.6 21.36 16 19.77 16H15.73C14.14 16 13.5 16.6 13.5 18.1V19.9C13.5 21.4 14.14 22 15.73 22H19.77C21.36 22 22 21.4 22 19.9Z"
            fill="#F3D1CB"
          />
          <path
            d="M10.5 13.1V19.9C10.5 21.4 9.86 22 8.27 22H4.23C2.64 22 2 21.4 2 19.9V13.1C2 11.6 2.64 11 4.23 11H8.27C9.86 11 10.5 11.6 10.5 13.1Z"
            fill="#F15845"
          />
          <path
            d="M10.5 4.1V5.9C10.5 7.4 9.86 8 8.27 8H4.23C2.64 8 2 7.4 2 5.9V4.1C2 2.6 2.64 2 4.23 2H8.27C9.86 2 10.5 2.6 10.5 4.1Z"
            fill="#F3D1CB"
          />
        </svg>
      );
      break;
    case "property2-default":
      icon = (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M9.16006 10.87C9.06006 10.86 8.94006 10.86 8.83006 10.87C6.45006 10.79 4.56006 8.84 4.56006 6.44C4.56006 3.99 6.54006 2 9.00006 2C11.4501 2 13.4401 3.99 13.4401 6.44C13.4301 8.84 11.5401 10.79 9.16006 10.87Z"
            stroke={color ? color : "#232323"}
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M16.4098 4C18.3498 4 19.9098 5.57 19.9098 7.5C19.9098 9.39 18.4098 10.93 16.5398 11C16.4598 10.99 16.3698 10.99 16.2798 11"
            stroke={color ? color : "#232323"}
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M4.16021 14.56C1.74021 16.18 1.74021 18.82 4.16021 20.43C6.91021 22.27 11.4202 22.27 14.1702 20.43C16.5902 18.81 16.5902 16.17 14.1702 14.56C11.4302 12.73 6.92021 12.73 4.16021 14.56Z"
            stroke={color ? color : "#232323"}
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M18.3398 20C19.0598 19.85 19.7398 19.56 20.2998 19.13C21.8598 17.96 21.8598 16.03 20.2998 14.86C19.7498 14.44 19.0798 14.16 18.3698 14"
            stroke={color ? color : "#232323"}
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      );
      break;
    case "property2-active":
      icon = (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M9 2C6.38 2 4.25 4.13 4.25 6.75C4.25 9.32 6.26 11.4 8.88 11.49C8.96 11.48 9.04 11.48 9.1 11.49C9.12 11.49 9.13 11.49 9.15 11.49C9.16 11.49 9.16 11.49 9.17 11.49C11.73 11.4 13.74 9.32 13.75 6.75C13.75 4.13 11.62 2 9 2Z"
            fill="#F15845"
          />
          <path
            d="M14.08 14.15C11.29 12.29 6.73996 12.29 3.92996 14.15C2.65996 15 1.95996 16.15 1.95996 17.38C1.95996 18.61 2.65996 19.75 3.91996 20.59C5.31996 21.53 7.15996 22 8.99996 22C10.84 22 12.68 21.53 14.08 20.59C15.34 19.74 16.04 18.6 16.04 17.36C16.03 16.13 15.34 14.99 14.08 14.15Z"
            fill="#F15845"
          />
          <path
            d="M19.9899 7.34001C20.1499 9.28001 18.7699 10.98 16.8599 11.21C16.8499 11.21 16.8499 11.21 16.8399 11.21H16.8099C16.7499 11.21 16.6899 11.21 16.6399 11.23C15.6699 11.28 14.7799 10.97 14.1099 10.4C15.1399 9.48001 15.7299 8.10001 15.6099 6.60001C15.5399 5.79001 15.2599 5.05001 14.8399 4.42001C15.2199 4.23001 15.6599 4.11001 16.1099 4.07001C18.0699 3.90001 19.8199 5.36001 19.9899 7.34001Z"
            fill="#F3D1CB"
          />
          <path
            d="M21.9902 16.59C21.9102 17.56 21.2902 18.4 20.2502 18.97C19.2502 19.52 17.9902 19.78 16.7402 19.75C17.4602 19.1 17.8802 18.29 17.9602 17.43C18.0602 16.19 17.4702 15 16.2902 14.05C15.6202 13.52 14.8402 13.1 13.9902 12.79C16.2002 12.15 18.9802 12.58 20.6902 13.96C21.6102 14.7 22.0802 15.63 21.9902 16.59Z"
            fill="#F3D1CB"
          />
        </svg>
      );
      break;
    case "property3-default":
      icon = (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M1.99609 8.5H11.4961"
            stroke={color ? color : "#232323"}
            stroke-width="1.5"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M5.99609 16.5H7.99609"
            stroke={color ? color : "#232323"}
            stroke-width="1.5"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M10.4961 16.5H14.4961"
            stroke={color ? color : "#232323"}
            stroke-width="1.5"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M21.9961 12.03V16.11C21.9961 19.62 21.1061 20.5 17.5561 20.5H6.43609C2.88609 20.5 1.99609 19.62 1.99609 16.11V7.89C1.99609 4.38 2.88609 3.5 6.43609 3.5H14.4961"
            stroke={color ? color : "#232323"}
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M19.0764 4.13L15.3664 7.84C15.2264 7.98 15.0864 8.26 15.0564 8.46L14.8564 9.88C14.7864 10.39 15.1464 10.75 15.6564 10.68L17.0764 10.48C17.2764 10.45 17.5564 10.31 17.6964 10.17L21.4064 6.46C22.0464 5.82 22.3464 5.08 21.4064 4.14C20.4564 3.19 19.7164 3.49 19.0764 4.13Z"
            stroke={color ? color : "#232323"}
            stroke-width="1.5"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M18.5459 4.66C18.8659 5.79 19.7459 6.67 20.8659 6.98"
            stroke={color ? color : "#232323"}
            stroke-width="1.5"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      );
      break;
    case "property3-active":
      icon = (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M13.5 4.60999V7.53999C13.5 8.20999 12.96 8.74999 12.29 8.74999H3.21C2.53 8.74999 2 8.18999 2 7.51999C2.01 6.38999 2.46 5.35999 3.21 4.60999C3.96 3.85999 5 3.39999 6.14 3.39999H12.29C12.96 3.39999 13.5 3.93999 13.5 4.60999Z"
            fill="#F3D1CB"
          />
          <path
            d="M2 11.46V16.46C2 18.75 3.85 20.6 6.14 20.6H17.85C20.14 20.6 22 18.74 22 16.45V11.46C22 10.79 21.46 10.25 20.79 10.25H3.21C2.54 10.25 2 10.79 2 11.46ZM8 17.25H6C5.59 17.25 5.25 16.91 5.25 16.5C5.25 16.09 5.59 15.75 6 15.75H8C8.41 15.75 8.75 16.09 8.75 16.5C8.75 16.91 8.41 17.25 8 17.25ZM14.5 17.25H10.5C10.09 17.25 9.75 16.91 9.75 16.5C9.75 16.09 10.09 15.75 10.5 15.75H14.5C14.91 15.75 15.25 16.09 15.25 16.5C15.25 16.91 14.91 17.25 14.5 17.25Z"
            fill="#F15845"
          />
          <path
            d="M19.97 1.75H17.03C15.76 1.75 15 2.51 15 3.78V6.72C15 7.99 15.76 8.75 17.03 8.75H19.97C21.24 8.75 22 7.99 22 6.72V3.78C22 2.51 21.24 1.75 19.97 1.75ZM18.01 7.32C17.98 7.35 17.91 7.39 17.86 7.39L16.82 7.54C16.79 7.55 16.75 7.55 16.72 7.55C16.57 7.55 16.44 7.5 16.35 7.4C16.23 7.28 16.18 7.11 16.21 6.93L16.36 5.89C16.37 5.84 16.4 5.77 16.43 5.74L18.13 4.04C18.16 4.11 18.19 4.19 18.22 4.27C18.26 4.35 18.3 4.42 18.34 4.49C18.37 4.55 18.41 4.61 18.45 4.65C18.49 4.71 18.53 4.77 18.56 4.8C18.58 4.83 18.59 4.84 18.6 4.85C18.69 4.96 18.79 5.06 18.88 5.13C18.9 5.15 18.92 5.17 18.93 5.17C18.98 5.21 19.04 5.26 19.08 5.29C19.14 5.33 19.19 5.37 19.25 5.4C19.32 5.44 19.4 5.48 19.48 5.52C19.56 5.56 19.64 5.59 19.71 5.61L18.01 7.32ZM20.4 4.93L20.07 5.26C20.06 5.28 20.03 5.29 20 5.29C19.99 5.29 19.98 5.29 19.97 5.29C19.25 5.08 18.68 4.51 18.47 3.79C18.46 3.75 18.47 3.71 18.5 3.68L18.83 3.35C19.37 2.81 19.88 2.82 20.41 3.35C20.68 3.62 20.81 3.88 20.81 4.14C20.8 4.4 20.67 4.66 20.4 4.93Z"
            fill="#F15845"
          />
        </svg>
      );
      break;
    case "property4-default":
      icon = (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M21 7V17C21 20 19.5 22 16 22H8C4.5 22 3 20 3 17V7C3 4 4.5 2 8 2H16C19.5 2 21 4 21 7Z"
            stroke={color ? color : "#232323"}
            stroke-width="1.5"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M14.5 4.5V6.5C14.5 7.6 15.4 8.5 16.5 8.5H18.5"
            stroke={color ? color : "#232323"}
            stroke-width="1.5"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M8 13H12"
            stroke={color ? color : "#232323"}
            stroke-width="1.5"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M8 17H16"
            stroke={color ? color : "#232323"}
            stroke-width="1.5"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      );
      break;
    case "property4-active":
      icon = (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M16 2H8C4.5 2 3 4 3 7V17C3 20 4.5 22 8 22H16C19.5 22 21 20 21 17V7C21 4 19.5 2 16 2ZM8 12.25H12C12.41 12.25 12.75 12.59 12.75 13C12.75 13.41 12.41 13.75 12 13.75H8C7.59 13.75 7.25 13.41 7.25 13C7.25 12.59 7.59 12.25 8 12.25ZM16 17.75H8C7.59 17.75 7.25 17.41 7.25 17C7.25 16.59 7.59 16.25 8 16.25H16C16.41 16.25 16.75 16.59 16.75 17C16.75 17.41 16.41 17.75 16 17.75ZM18.5 9.25H16.5C14.98 9.25 13.75 8.02 13.75 6.5V4.5C13.75 4.09 14.09 3.75 14.5 3.75C14.91 3.75 15.25 4.09 15.25 4.5V6.5C15.25 7.19 15.81 7.75 16.5 7.75H18.5C18.91 7.75 19.25 8.09 19.25 8.5C19.25 8.91 18.91 9.25 18.5 9.25Z"
            fill="#F15845"
          />
        </svg>
      );
      break;
    case "property5-default":
      icon = (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M5.48009 18.49V15.57C5.48009 14.6 6.24009 13.73 7.32009 13.73C8.29009 13.73 9.16008 14.49 9.16008 15.57V18.38C9.16008 20.33 7.54007 21.95 5.59007 21.95C3.64007 21.95 2.02007 20.32 2.02007 18.38V12.22C1.91007 6.59997 6.35008 2.04999 11.9701 2.04999C17.5901 2.04999 22.0201 6.59999 22.0201 12.11V18.27C22.0201 20.22 20.4001 21.84 18.4501 21.84C16.5001 21.84 14.8801 20.22 14.8801 18.27V15.46C14.8801 14.49 15.6401 13.62 16.7201 13.62C17.6901 13.62 18.5601 14.38 18.5601 15.46V18.49"
            stroke={color ? color : "#232323"}
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M15.53 9.11999H14.72C14.5 9.11999 14.29 9.25 14.19 9.44L13.44 10.94C13.33 11.16 13.02 11.16 12.91 10.94L11.07 7.27002C10.96 7.06002 10.66 7.05001 10.55 7.26001L9.70996 8.80999C9.60996 8.99999 9.40997 9.11999 9.18997 9.11999H8.45996"
            stroke={color ? color : "#232323"}
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      );
      break;
    case "property5-active":
      icon = (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M13.1802 11.86C12.7802 11.86 12.4202 11.64 12.2502 11.28L10.8002 8.39L10.3802 9.17C10.1502 9.6 9.69021 9.87 9.20021 9.87H8.47022C8.06022 9.87 7.72021 9.53 7.72021 9.12C7.72021 8.71 8.06022 8.37 8.47022 8.37H9.11021L9.90021 6.91C10.0902 6.57 10.4702 6.34 10.8302 6.36C11.2202 6.36 11.5702 6.59 11.7502 6.93L13.1802 9.79L13.5202 9.1C13.7502 8.64 14.2002 8.36 14.7202 8.36H15.5302C15.9402 8.36 16.2802 8.7 16.2802 9.11C16.2802 9.52 15.9402 9.86 15.5302 9.86H14.8202L14.1102 11.27C13.9302 11.64 13.5802 11.86 13.1802 11.86Z"
            fill="#F3D1CB"
          />
          <path
            d="M2.74982 18.65C2.33982 18.65 1.99982 18.31 1.99982 17.9V12.2C1.94982 9.48999 2.95982 6.92999 4.83982 5.00999C6.71982 3.09999 9.23982 2.04999 11.9498 2.04999C17.4898 2.04999 21.9998 6.55999 21.9998 12.1V17.8C21.9998 18.21 21.6598 18.55 21.2498 18.55C20.8398 18.55 20.4998 18.21 20.4998 17.8V12.1C20.4998 7.38999 16.6698 3.54999 11.9498 3.54999C9.63982 3.54999 7.49982 4.43999 5.90982 6.05999C4.30982 7.68999 3.45982 9.85999 3.49982 12.18V17.89C3.49982 18.31 3.16982 18.65 2.74982 18.65Z"
            fill="#F15845"
          />
          <path
            d="M5.94 12.45H5.81C3.71 12.45 2 14.16 2 16.26V18.14C2 20.24 3.71 21.95 5.81 21.95H5.94C8.04 21.95 9.75 20.24 9.75 18.14V16.26C9.75 14.16 8.04 12.45 5.94 12.45Z"
            fill="#F15845"
          />
          <path
            d="M18.19 12.45H18.06C15.96 12.45 14.25 14.16 14.25 16.26V18.14C14.25 20.24 15.96 21.95 18.06 21.95H18.19C20.29 21.95 22 20.24 22 18.14V16.26C22 14.16 20.29 12.45 18.19 12.45Z"
            fill="#F15845"
          />
        </svg>
      );
      break;
    case "property6-default":
      icon = (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g id="vuesax/outline/clock">
            <g id="clock">
              <path
                id="Vector"
                d="M9.99984 18.9583C5.05817 18.9583 1.0415 14.9416 1.0415 9.99996C1.0415 5.05829 5.05817 1.04163 9.99984 1.04163C14.9415 1.04163 18.9582 5.05829 18.9582 9.99996C18.9582 14.9416 14.9415 18.9583 9.99984 18.9583ZM9.99984 2.29163C5.74984 2.29163 2.2915 5.74996 2.2915 9.99996C2.2915 14.25 5.74984 17.7083 9.99984 17.7083C14.2498 17.7083 17.7082 14.25 17.7082 9.99996C17.7082 5.74996 14.2498 2.29163 9.99984 2.29163Z"
                fill="#D9D9D9"
              />
              <path
                id="Vector_2"
                d="M13.0919 13.275C12.9835 13.275 12.8752 13.25 12.7752 13.1833L10.1919 11.6416C9.55019 11.2583 9.0752 10.4166 9.0752 9.67497V6.2583C9.0752 5.91663 9.35853 5.6333 9.7002 5.6333C10.0419 5.6333 10.3252 5.91663 10.3252 6.2583V9.67497C10.3252 9.97497 10.5752 10.4166 10.8335 10.5666L13.4169 12.1083C13.7169 12.2833 13.8085 12.6666 13.6335 12.9666C13.5085 13.1666 13.3002 13.275 13.0919 13.275Z"
                fill="#D9D9D9"
              />
            </g>
          </g>
        </svg>
      );
      break;
    case "property7-default":
      icon = (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g id="vuesax/linear/bag-2">
            <g id="bag-2">
              <path
                id="Vector"
                d="M6.25 6.39167V5.58334C6.25 3.70834 7.75833 1.86667 9.63333 1.69167C11.8667 1.47501 13.75 3.23334 13.75 5.42501V6.57501"
                stroke="#D9D9D9"
                stroke-width="1.5"
                stroke-miterlimit="10"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                id="Vector_2"
                d="M7.49986 18.3333H12.4999C15.8499 18.3333 16.4499 16.9916 16.6249 15.3583L17.2499 10.3583C17.4749 8.32496 16.8915 6.66663 13.3332 6.66663H6.66652C3.10819 6.66663 2.52486 8.32496 2.74986 10.3583L3.37486 15.3583C3.54986 16.9916 4.14986 18.3333 7.49986 18.3333Z"
                stroke="#D9D9D9"
                stroke-width="1.5"
                stroke-miterlimit="10"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                id="Vector_3"
                d="M12.9131 10H12.9206"
                stroke="#D9D9D9"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                id="Vector_4"
                d="M7.07859 10H7.08608"
                stroke="#D9D9D9"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </g>
          </g>
        </svg>
      );
      break;
    case "property8-default":
      icon = (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g id="vuesax/linear/timer">
            <g id="timer">
              <path
                id="Vector"
                d="M17.2918 11.0417C17.2918 15.0667 14.0252 18.3333 10.0002 18.3333C5.97516 18.3333 2.7085 15.0667 2.7085 11.0417C2.7085 7.01667 5.97516 3.75 10.0002 3.75C14.0252 3.75 17.2918 7.01667 17.2918 11.0417Z"
                stroke="#D9D9D9"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                id="Vector_2"
                d="M10 6.66663V10.8333"
                stroke="#D9D9D9"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                id="Vector_3"
                d="M7.5 1.66663H12.5"
                stroke="#D9D9D9"
                stroke-width="1.5"
                stroke-miterlimit="10"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </g>
          </g>
        </svg>
      );
      break;
    case "property9-default":
      icon = (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g id="vuesax/outline/setting-2">
            <g id="setting-2">
              <path
                id="Vector"
                d="M10 13.125C8.275 13.125 6.875 11.725 6.875 10C6.875 8.275 8.275 6.875 10 6.875C11.725 6.875 13.125 8.275 13.125 10C13.125 11.725 11.725 13.125 10 13.125ZM10 8.125C8.96667 8.125 8.125 8.96667 8.125 10C8.125 11.0333 8.96667 11.875 10 11.875C11.0333 11.875 11.875 11.0333 11.875 10C11.875 8.96667 11.0333 8.125 10 8.125Z"
                fill="#D9D9D9"
              />
              <path
                id="Vector_2"
                d="M12.6748 18.4916C12.4998 18.4916 12.3248 18.4666 12.1498 18.425C11.6332 18.2833 11.1998 17.9583 10.9248 17.5L10.8248 17.3333C10.3332 16.4833 9.65817 16.4833 9.1665 17.3333L9.07484 17.4916C8.79984 17.9583 8.3665 18.2916 7.84984 18.425C7.32484 18.5666 6.78317 18.4916 6.32484 18.2166L4.8915 17.3916C4.38317 17.1 4.0165 16.625 3.85817 16.05C3.70817 15.475 3.78317 14.8833 4.07484 14.375C4.3165 13.95 4.38317 13.5666 4.2415 13.325C4.09984 13.0833 3.7415 12.9416 3.24984 12.9416C2.03317 12.9416 1.0415 11.95 1.0415 10.7333V9.26662C1.0415 8.04995 2.03317 7.05829 3.24984 7.05829C3.7415 7.05829 4.09984 6.91662 4.2415 6.67495C4.38317 6.43329 4.32484 6.04995 4.07484 5.62495C3.78317 5.11662 3.70817 4.51662 3.85817 3.94995C4.00817 3.37495 4.37484 2.89995 4.8915 2.60829L6.33317 1.78329C7.27484 1.22495 8.5165 1.54995 9.08317 2.50829L9.18317 2.67495C9.67484 3.52495 10.3498 3.52495 10.8415 2.67495L10.9332 2.51662C11.4998 1.54995 12.7415 1.22495 13.6915 1.79162L15.1248 2.61662C15.6332 2.90829 15.9998 3.38329 16.1582 3.95829C16.3082 4.53329 16.2332 5.12495 15.9415 5.63329C15.6998 6.05829 15.6332 6.44162 15.7748 6.68329C15.9165 6.92495 16.2748 7.06662 16.7665 7.06662C17.9832 7.06662 18.9748 8.05829 18.9748 9.27495V10.7416C18.9748 11.9583 17.9832 12.95 16.7665 12.95C16.2748 12.95 15.9165 13.0916 15.7748 13.3333C15.6332 13.575 15.6915 13.9583 15.9415 14.3833C16.2332 14.8916 16.3165 15.4916 16.1582 16.0583C16.0082 16.6333 15.6415 17.1083 15.1248 17.4L13.6832 18.225C13.3665 18.4 13.0248 18.4916 12.6748 18.4916ZM9.99984 15.4083C10.7415 15.4083 11.4332 15.875 11.9082 16.7L11.9998 16.8583C12.0998 17.0333 12.2665 17.1583 12.4665 17.2083C12.6665 17.2583 12.8665 17.2333 13.0332 17.1333L14.4748 16.3C14.6915 16.175 14.8582 15.9666 14.9248 15.7166C14.9915 15.4666 14.9582 15.2083 14.8332 14.9916C14.3582 14.175 14.2998 13.3333 14.6665 12.6916C15.0332 12.05 15.7915 11.6833 16.7415 11.6833C17.2748 11.6833 17.6998 11.2583 17.6998 10.725V9.25829C17.6998 8.73329 17.2748 8.29995 16.7415 8.29995C15.7915 8.29995 15.0332 7.93329 14.6665 7.29162C14.2998 6.64995 14.3582 5.80829 14.8332 4.99162C14.9582 4.77495 14.9915 4.51662 14.9248 4.26662C14.8582 4.01662 14.6998 3.81662 14.4832 3.68329L13.0415 2.85829C12.6832 2.64162 12.2082 2.76662 11.9915 3.13329L11.8998 3.29162C11.4248 4.11662 10.7332 4.58329 9.9915 4.58329C9.24984 4.58329 8.55817 4.11662 8.08317 3.29162L7.9915 3.12495C7.78317 2.77495 7.3165 2.64995 6.95817 2.85829L5.5165 3.69162C5.29984 3.81662 5.13317 4.02495 5.0665 4.27495C4.99984 4.52495 5.03317 4.78329 5.15817 4.99995C5.63317 5.81662 5.6915 6.65829 5.32484 7.29995C4.95817 7.94162 4.19984 8.30829 3.24984 8.30829C2.7165 8.30829 2.2915 8.73329 2.2915 9.26662V10.7333C2.2915 11.2583 2.7165 11.6916 3.24984 11.6916C4.19984 11.6916 4.95817 12.0583 5.32484 12.7C5.6915 13.3416 5.63317 14.1833 5.15817 15C5.03317 15.2166 4.99984 15.475 5.0665 15.725C5.13317 15.975 5.2915 16.175 5.50817 16.3083L6.94984 17.1333C7.12484 17.2416 7.33317 17.2666 7.52484 17.2166C7.72484 17.1666 7.8915 17.0333 7.99984 16.8583L8.0915 16.7C8.5665 15.8833 9.25817 15.4083 9.99984 15.4083Z"
                fill="#D9D9D9"
              />
            </g>
          </g>
        </svg>
      );
      break;
    case "property10-default":
      icon = (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
        >
          <path
            d="M7.63332 9.05835C7.54999 9.05002 7.44999 9.05002 7.35832 9.05835C5.37499 8.99169 3.79999 7.36669 3.79999 5.36669C3.79999 3.32502 5.44999 1.66669 7.49999 1.66669C9.54165 1.66669 11.2 3.32502 11.2 5.36669C11.1917 7.36669 9.61665 8.99169 7.63332 9.05835Z"
            stroke="#D9D9D9"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M13.675 3.33331C15.2917 3.33331 16.5917 4.64165 16.5917 6.24998C16.5917 7.82498 15.3417 9.10831 13.7833 9.16665C13.7167 9.15831 13.6417 9.15831 13.5667 9.16665"
            stroke="#D9D9D9"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M3.46666 12.1333C1.45 13.4833 1.45 15.6833 3.46666 17.025C5.75833 18.5583 9.51666 18.5583 11.8083 17.025C13.825 15.675 13.825 13.475 11.8083 12.1333C9.525 10.6083 5.76666 10.6083 3.46666 12.1333Z"
            stroke="#D9D9D9"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M15.2833 16.6667C15.8833 16.5417 16.45 16.3 16.9167 15.9417C18.2167 14.9667 18.2167 13.3584 16.9167 12.3834C16.4583 12.0334 15.9 11.8 15.3083 11.6667"
            stroke="#D9D9D9"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      );
      break;
    case "property11-default":
      icon = (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="none"
        >
          <path
            d="M1.5 6.75V4.875C1.5 3.0075 3.0075 1.5 4.875 1.5H6.75"
            stroke="#D9D9D9"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M11.25 1.5H13.125C14.9925 1.5 16.5 3.0075 16.5 4.875V6.75"
            stroke="#D9D9D9"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M16.5 12V13.125C16.5 14.9925 14.9925 16.5 13.125 16.5H12"
            stroke="#D9D9D9"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M6.75 16.5H4.875C3.0075 16.5 1.5 14.9925 1.5 13.125V11.25"
            stroke="#D9D9D9"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      );
      break;
    case "property12-default":
      icon = (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M17.2916 11.0417C17.2916 15.0667 14.025 18.3333 9.99998 18.3333C5.97498 18.3333 2.70831 15.0667 2.70831 11.0417C2.70831 7.01667 5.97498 3.75 9.99998 3.75C14.025 3.75 17.2916 7.01667 17.2916 11.0417Z"
            stroke="#D9D9D9"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M10 6.66669V10.8334"
            stroke="#D9D9D9"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M7.5 1.66669H12.5"
            stroke="#D9D9D9"
            stroke-width="1.5"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      );
      break;
    case "home":
      icon = (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M12 18V15"
            stroke="#232323"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M10.0698 2.82L3.13978 8.37C2.35978 8.99 1.85978 10.3 2.02978 11.28L3.35978 19.24C3.59978 20.66 4.95978 21.81 6.39978 21.81H17.5998C19.0298 21.81 20.3998 20.65 20.6398 19.24L21.9698 11.28C22.1298 10.3 21.6298 8.99 20.8598 8.37L13.9298 2.83C12.8598 1.97 11.1298 1.97 10.0698 2.82Z"
            stroke="#232323"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      );
      break;
    case "resources":
      icon = (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M22 16.74V4.67001C22 3.47001 21.02 2.58001 19.83 2.68001H19.77C17.67 2.86001 14.48 3.93001 12.7 5.05001L12.53 5.16001C12.24 5.34001 11.76 5.34001 11.47 5.16001L11.22 5.01001C9.44 3.90001 6.26 2.84001 4.16 2.67001C2.97 2.57001 2 3.47001 2 4.66001V16.74C2 17.7 2.78 18.6 3.74 18.72L4.03 18.76C6.2 19.05 9.55 20.15 11.47 21.2L11.51 21.22C11.78 21.37 12.21 21.37 12.47 21.22C14.39 20.16 17.75 19.05 19.93 18.76L20.26 18.72C21.22 18.6 22 17.7 22 16.74Z"
            stroke="#232323"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M12 5.49001V20.49"
            stroke="#232323"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M7.75 8.49001H5.5"
            stroke="#232323"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M8.5 11.49H5.5"
            stroke="#232323"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      );
      break;
    case "green":
      icon = (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="12" cy="12" r="11.5" stroke="#2EB67D" />
        </svg>
      );
      break;
    case "aqua":
      icon = (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="12" cy="12" r="11.5" stroke="#36C5F0" />
        </svg>
      );
      break;
    case "yellow":
      icon = (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="12" cy="12" r="11.5" stroke="#ECB22E" />
        </svg>
      );
      break;
    case "watermelon":
      icon = (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="12" cy="12" r="11.5" stroke="#E3828D" />
        </svg>
      );
      break;
    case "gray":
      icon = (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="12" cy="12" r="11.5" stroke="#646464" />
        </svg>
      );
      break;
    case "orangered":
      icon = (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="12" cy="12" r="11.5" stroke="#F15845" />
        </svg>
      );
      break;
    case "blue":
      icon = (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="12" cy="12" r="11.5" stroke="#0080FF" />
        </svg>
      );
      break;
    case "tick-circle":
      icon = (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M12 24C18.6 24 24 18.6 24 12C24 5.4 18.6 0 12 0C5.4 0 0 5.4 0 12C0 18.6 5.4 24 12 24Z"
            fill="#2EB67D"
          />
          <path
            d="M6.90039 12.0001L10.2964 15.3961L17.1004 8.6041"
            fill="#2EB67D"
          />
          <path
            d="M6.90039 12.0001L10.2964 15.3961L17.1004 8.6041"
            stroke="white"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      );
      break;
    case "star":
      icon = (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M12 0L15.3997 7.32065L23.4127 8.2918L17.5009 13.7874L19.0534 21.7082L12 17.784L4.94658 21.7082L6.49909 13.7874L0.587322 8.2918L8.60025 7.32065L12 0Z"
            fill="#ECB22E"
          />
        </svg>
      );
      break;
    case "more":
      icon = (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="12" cy="6" r="2" fill="#232323" />
          <circle cx="12" cy="12" r="2" fill="#232323" />
          <circle cx="12" cy="18" r="2" fill="#232323" />
        </svg>
      );
      break;
    case "info-circle":
      icon = (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M12 0C5.388 0 0 5.388 0 12C0 18.612 5.388 24 12 24C18.612 24 24 18.612 24 12C24 5.388 18.612 0 12 0ZM11.1 7.2C11.1 6.708 11.508 6.3 12 6.3C12.492 6.3 12.9 6.708 12.9 7.2V13.2C12.9 13.692 12.492 14.1 12 14.1C11.508 14.1 11.1 13.692 11.1 13.2V7.2ZM13.104 17.256C13.044 17.412 12.96 17.532 12.852 17.652C12.732 17.76 12.6 17.844 12.456 17.904C12.312 17.964 12.156 18 12 18C11.844 18 11.688 17.964 11.544 17.904C11.4 17.844 11.268 17.76 11.148 17.652C11.04 17.532 10.956 17.412 10.896 17.256C10.836 17.112 10.8 16.956 10.8 16.8C10.8 16.644 10.836 16.488 10.896 16.344C10.956 16.2 11.04 16.068 11.148 15.948C11.268 15.84 11.4 15.756 11.544 15.696C11.832 15.576 12.168 15.576 12.456 15.696C12.6 15.756 12.732 15.84 12.852 15.948C12.96 16.068 13.044 16.2 13.104 16.344C13.164 16.488 13.2 16.644 13.2 16.8C13.2 16.956 13.164 17.112 13.104 17.256Z"
            fill={color ? color : "#232323"}
          />
        </svg>
      );
      break;
    case "info-circle-2":
      icon = (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="14"
          height="14"
          viewBox="0 0 14 14"
          fill="none"
        >
          <path
            d="M7.00001 0.349976C3.33201 0.349976 0.350006 3.33198 0.350006 6.99998C0.350006 10.668 3.33201 13.65 7.00001 13.65C10.668 13.65 13.65 10.668 13.65 6.99998C13.65 3.33198 10.668 0.349976 7.00001 0.349976ZM8.21801 9.67398C8.07801 10.024 7.75601 10.626 7.11201 10.976C6.72001 11.186 6.44001 11.172 6.37001 11.172C6.28601 11.172 5.72601 11.144 5.48801 10.696C5.36201 10.458 5.39001 10.234 5.41801 10.122L6.46801 6.25798H5.93601C5.86601 6.25798 5.81001 6.20198 5.79601 6.14598L5.76801 5.92198C5.75401 5.85198 5.81001 5.78198 5.88001 5.76798L8.05001 5.40398C8.14801 5.38998 8.23201 5.47398 8.20401 5.57198L7.05601 9.84198C7.00001 10.038 7.23801 10.178 7.39201 10.038C7.60201 9.84198 7.74201 9.63198 7.82601 9.46398C7.86801 9.39398 7.95201 9.36598 8.02201 9.40798C8.07801 9.43598 8.12001 9.47798 8.17601 9.50598C8.21801 9.54798 8.23201 9.61798 8.21801 9.67398ZM7.67201 4.67598C7.15401 4.67598 6.73401 4.25598 6.73401 3.73798C6.73401 3.21998 7.15401 2.79998 7.67201 2.79998C8.19001 2.79998 8.61001 3.21998 8.61001 3.73798C8.61001 4.25598 8.19001 4.67598 7.67201 4.67598Z"
            fill="#646464"
          />
        </svg>
      );
      break;
    case "tick":
      icon = (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M23.6617 3.31057C24.0978 3.7392 24.1145 4.45131 23.6988 4.9011L9.14483 20.6511C8.93882 20.874 8.65321 21.0001 8.3546 21C8.05599 20.9999 7.77048 20.8735 7.56467 20.6504L0.3005 12.7754C-0.114755 12.3252 -0.0975071 11.6131 0.339025 11.1849C0.775556 10.7567 1.46607 10.7744 1.88132 11.2246L8.3546 16L22.1193 3.3489C22.535 2.89911 23.2255 2.88195 23.6617 3.31057Z"
            fill="#232323"
          />
        </svg>
      );
      break;
    case "error":
      icon = (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M21.76 15.92L15.36 4.4C14.5 2.85 13.31 2 12 2C10.69 2 9.49998 2.85 8.63998 4.4L2.23998 15.92C1.42998 17.39 1.33998 18.8 1.98998 19.91C2.63998 21.02 3.91998 21.63 5.59998 21.63H18.4C20.08 21.63 21.36 21.02 22.01 19.91C22.66 18.8 22.57 17.38 21.76 15.92ZM11.25 9C11.25 8.59 11.59 8.25 12 8.25C12.41 8.25 12.75 8.59 12.75 9V14C12.75 14.41 12.41 14.75 12 14.75C11.59 14.75 11.25 14.41 11.25 14V9ZM12.71 17.71C12.66 17.75 12.61 17.79 12.56 17.83C12.5 17.87 12.44 17.9 12.38 17.92C12.32 17.95 12.26 17.97 12.19 17.98C12.13 17.99 12.06 18 12 18C11.94 18 11.87 17.99 11.8 17.98C11.74 17.97 11.68 17.95 11.62 17.92C11.56 17.9 11.5 17.87 11.44 17.83C11.39 17.79 11.34 17.75 11.29 17.71C11.11 17.52 11 17.26 11 17C11 16.74 11.11 16.48 11.29 16.29C11.34 16.25 11.39 16.21 11.44 16.17C11.5 16.13 11.56 16.1 11.62 16.08C11.68 16.05 11.74 16.03 11.8 16.02C11.93 15.99 12.07 15.99 12.19 16.02C12.26 16.03 12.32 16.05 12.38 16.08C12.44 16.1 12.5 16.13 12.56 16.17C12.61 16.21 12.66 16.25 12.71 16.29C12.89 16.48 13 16.74 13 17C13 17.26 12.89 17.52 12.71 17.71Z"
            fill="#232323"
          />
        </svg>
      );
      break;
    case "error-2":
      icon = (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
        >
          <path
            d="M9.99998 17.8416H4.94998C2.05832 17.8416 0.849985 15.775 2.24998 13.25L4.84998 8.56665L7.29998 4.16665C8.78332 1.49165 11.2167 1.49165 12.7 4.16665L15.15 8.57498L17.75 13.2583C19.15 15.7833 17.9333 17.85 15.05 17.85H9.99998V17.8416Z"
            fill="#ECB22E"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M9.99542 14.1667H10.0029H9.99542Z"
            fill="#D9D9D9"
          />
          <path
            d="M9.99542 14.1667H10.0029"
            stroke="white"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M10 7.5V11.6667"
            stroke="white"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      );
      break;
    case "play":
      icon = (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M0 11.9998V5.18962C0 -0.283386 2.33911 -1.26142 7.70366 1.47509L14.0767 4.81805L20.3097 8.28524C25.6742 11.0217 24.9739 12.9782 19.6093 15.7147L14.0767 19.1816L7.70366 22.525C2.33911 25.2615 0 24.2833 0 18.8103V11.9998Z"
            fill={`${color ? color : "#1A1A1A"}`}
          />
        </svg>
      );
      break;
    case "left":
      icon = (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M16.7688 2.25105C17.0771 2.58579 17.0771 3.1285 16.7688 3.46323L8.90596 12L16.7688 20.5368C17.0771 20.8715 17.0771 21.4142 16.7688 21.749C16.4605 22.0837 15.9606 22.0837 15.6523 21.749L7.23123 12.6061C7.08318 12.4453 7 12.2273 7 12C7 11.7727 7.08318 11.5547 7.23123 11.3939L15.6523 2.25105C15.9606 1.91632 16.4605 1.91632 16.7688 2.25105Z"
            fill="#232323"
          />
        </svg>
      );
      break;
    case "right":
      icon = (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M7.23123 2.25105C6.92292 2.58579 6.92292 3.1285 7.23123 3.46323L15.094 12L7.23123 20.5368C6.92292 20.8715 6.92292 21.4142 7.23123 21.749C7.53954 22.0837 8.03941 22.0837 8.34772 21.749L16.7688 12.6061C16.9168 12.4453 17 12.2273 17 12C17 11.7727 16.9168 11.5547 16.7688 11.3939L8.34772 2.25105C8.03941 1.91632 7.53954 1.91632 7.23123 2.25105Z"
            fill="#232323"
          />
        </svg>
      );
      break;
    case "up":
      icon = (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M2.25056 16.7688C2.5853 17.0771 3.12801 17.0771 3.46275 16.7688L11.9995 8.90596L20.5363 16.7688C20.871 17.0771 21.4137 17.0771 21.7485 16.7688C22.0832 16.4605 22.0832 15.9606 21.7485 15.6523L12.6056 7.23123C12.4449 7.08318 12.2268 7 11.9995 7C11.7722 7 11.5542 7.08318 11.3934 7.23123L2.25056 15.6523C1.91583 15.9606 1.91583 16.4605 2.25056 16.7688Z"
            fill={color ? color : "#232323"}
          />
        </svg>
      );
      break;
    case "down":
      icon = (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M21.7489 7.23123C21.4142 6.92292 20.8715 6.92292 20.5368 7.23123L12 15.094L3.46323 7.23123C3.1285 6.92292 2.58578 6.92292 2.25105 7.23123C1.91632 7.53954 1.91632 8.03941 2.25105 8.34772L11.3939 16.7688C11.5547 16.9168 11.7727 17 12 17C12.2273 17 12.4453 16.9168 12.6061 16.7688L21.7489 8.34772C22.0837 8.03941 22.0837 7.53954 21.7489 7.23123Z"
            fill="#232323"
          />
        </svg>
      );
      break;
    case "white-circle-tick":
      icon = (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
        >
          <path
            d="M12 22C17.5 22 22 17.5 22 12C22 6.5 17.5 2 12 2C6.5 2 2 6.5 2 12C2 17.5 6.5 22 12 22Z"
            stroke="white"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M7.75 12L10.58 14.83L16.25 9.16998"
            stroke="white"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      );
      break;
    case "white-circle-cross":
      icon = (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
        >
          <path
            d="M12 22C17.5 22 22 17.5 22 12C22 6.5 17.5 2 12 2C6.5 2 2 6.5 2 12C2 17.5 6.5 22 12 22Z"
            stroke="white"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M9.16998 14.83L14.83 9.16998"
            stroke="white"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M14.83 14.83L9.16998 9.16998"
            stroke="white"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      );
      break;
    case "comment":
      icon = (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="14"
          height="13"
          viewBox="0 0 14 13"
          fill="none"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M1.18373 8.98206C0.387488 8.00383 0.000159264 6.97192 0.000159264 5.83327C0.000159264 2.6168 3.14021 0 7.00008 0C10.86 0 14 2.6168 14 5.83327C14 9.04973 10.86 11.6665 7.00008 11.6665C5.96409 11.6665 5.46126 11.4688 4.74552 11.1666C3.66578 11.8964 2.28972 12.3257 1.29281 12.6366C1.10206 12.6961 0.924732 12.7515 0.766068 12.804C0.705985 12.8239 0.644152 12.8332 0.583486 12.8332C0.385155 12.8332 0.19499 12.7317 0.0864916 12.5555C-0.0552568 12.3257 -0.0196743 12.0288 0.171074 11.8374C1.17906 10.8289 1.2059 9.43939 1.18373 8.98206Z"
            fill="#232323"
          />
        </svg>
      );
      break;
    case "small-document":
      icon = (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M22 10V15C22 20 20 22 15 22H9C4 22 2 20 2 15V9C2 4 4 2 9 2H14"
            stroke="#292D32"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M22 10H18C15 10 14 9 14 6V2L22 10Z"
            stroke="#292D32"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M7 13H13"
            stroke="#292D32"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M7 17H11"
            stroke="#292D32"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      );
      break;
    case "send":
      icon = (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="19"
          height="19"
          viewBox="0 0 19 19"
          fill="none"
        >
          <path
            d="M9.5 0C4.26 0 0 4.26 0 9.5C0 14.74 4.26 19 9.5 19C14.74 19 19 14.74 19 9.5C19 4.26 14.74 0 9.5 0ZM13.08 8.14C12.96 8.26 12.82 8.32 12.66 8.32C12.5 8.32 12.36 8.26 12.24 8.14L10.1 5.98V14.44C10.1 14.76 9.84 15.04 9.5 15.04C9.18 15.04 8.9 14.78 8.9 14.44V5.98L6.76 8.14C6.52 8.38 6.16 8.38 5.92 8.14C5.68 7.9 5.68 7.54 5.92 7.3L9.08 4.14C9.32 3.9 9.68 3.9 9.92 4.14L13.08 7.3C13.32 7.54 13.32 7.9 13.08 8.14Z"
            fill="#EFEFEF"
          />
        </svg>
      );
      break;
    case "watch-color":
      icon = (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M18.3333 9.99996C18.3333 14.6 14.6 18.3333 9.99999 18.3333C5.39999 18.3333 1.66666 14.6 1.66666 9.99996C1.66666 5.39996 5.39999 1.66663 9.99999 1.66663C14.6 1.66663 18.3333 5.39996 18.3333 9.99996Z"
            stroke="#292D32"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M13.0917 12.65L10.5083 11.1083C10.0583 10.8416 9.69168 10.2 9.69168 9.67497V6.2583"
            stroke="#F15845"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      );
      break;
    case "round-small-color":
      icon = (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M11 1C9.37394 1 7.7724 1.39653 6.33418 2.15522C4.89597 2.91391 3.66446 4.01188 2.74637 5.35397C1.82829 6.69606 1.25134 8.24179 1.06551 9.8572C0.879688 11.4726 1.09059 13.109 1.67995 14.6245L11 11V1Z"
            fill="#F15845"
          />
          <path
            d="M17.6667 10C17.6667 14.6 13.9333 18.3333 9.33333 18.3333C4.73333 18.3333 1 14.6 1 10C1 5.4 4.73333 1.66666 9.33333 1.66666C13.9333 1.66666 17.6667 5.4 17.6667 10Z"
            stroke="#292D32"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      );
      break;
    case "soap-color":
      icon = (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M6.25 6.39167V5.58334C6.25 3.70834 7.75833 1.86667 9.63333 1.69167C11.8667 1.47501 13.75 3.23334 13.75 5.42501V6.57501"
            stroke="#F15845"
            stroke-width="1.5"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M7.50001 18.3333H12.5C15.85 18.3333 16.45 16.9916 16.625 15.3583L17.25 10.3583C17.475 8.32496 16.8917 6.66663 13.3333 6.66663H6.66667C3.10834 6.66663 2.52501 8.32496 2.75001 10.3583L3.37501 15.3583C3.55001 16.9916 4.15001 18.3333 7.50001 18.3333Z"
            stroke="#292D32"
            stroke-width="1.5"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M12.9129 10H12.9204"
            stroke="#F15845"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M7.07875 10H7.08623"
            stroke="#F15845"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      );
      break;
    case "document-color":
      icon = (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M7.5 18.3333H12.5C16.6667 18.3333 18.3333 16.6666 18.3333 12.5V7.49996C18.3333 3.33329 16.6667 1.66663 12.5 1.66663H7.5C3.33334 1.66663 1.66667 3.33329 1.66667 7.49996V12.5C1.66667 16.6666 3.33334 18.3333 7.5 18.3333Z"
            stroke="#292D32"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M13.125 7.5H6.875"
            stroke="#F15845"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M13.125 12.5H6.875"
            stroke="#F15845"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      );
      break;
    case "danger-color":
      icon = (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="22"
          height="22"
          viewBox="0 0 22 22"
          fill="none"
        >
          <path
            d="M11 8.25V12.8333"
            stroke="#E01E1E"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M11 19.6258H5.44499C2.26416 19.6258 0.934989 17.3525 2.47499 14.575L5.33499 9.42333L8.02999 4.58333C9.66166 1.64083 12.3383 1.64083 13.97 4.58333L16.665 9.4325L19.525 14.5842C21.065 17.3617 19.7267 19.635 16.555 19.635H11V19.6258Z"
            stroke="#E01E1E"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M10.995 15.5833H11.0032"
            stroke="#E01E1E"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      );
      break;
    case "logout":
      icon = (
        <svg
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M8.90002 7.55999C9.21002 3.95999 11.06 2.48999 15.11 2.48999H15.24C19.71 2.48999 21.5 4.27999 21.5 8.74999V15.27C21.5 19.74 19.71 21.53 15.24 21.53H15.11C11.09 21.53 9.24002 20.08 8.91002 16.54"
            stroke="#292D32"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M15 12H3.62"
            stroke="#292D32"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M5.85 8.6499L2.5 11.9999L5.85 15.3499"
            stroke="#292D32"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      );
      break;
    case "dot-action":
      icon = (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
        >
          <path
            d="M5 10C3.9 10 3 10.9 3 12C3 13.1 3.9 14 5 14C6.1 14 7 13.1 7 12C7 10.9 6.1 10 5 10Z"
            stroke="#292D32"
            stroke-width="1.5"
          />
          <path
            d="M19 10C17.9 10 17 10.9 17 12C17 13.1 17.9 14 19 14C20.1 14 21 13.1 21 12C21 10.9 20.1 10 19 10Z"
            stroke="#292D32"
            stroke-width="1.5"
          />
          <path
            d="M12 10C10.9 10 10 10.9 10 12C10 13.1 10.9 14 12 14C13.1 14 14 13.1 14 12C14 10.9 13.1 10 12 10Z"
            stroke="#292D32"
            stroke-width="1.5"
          />
        </svg>
      );
      break;
    case "edit-2":
      icon = (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
        >
          <path
            d="M9.16669 1.66666H7.50002C3.33335 1.66666 1.66669 3.33332 1.66669 7.49999V12.5C1.66669 16.6667 3.33335 18.3333 7.50002 18.3333H12.5C16.6667 18.3333 18.3334 16.6667 18.3334 12.5V10.8333"
            stroke="#292D32"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M13.3667 2.51666L6.80002 9.08333C6.55002 9.33333 6.30002 9.825 6.25002 10.1833L5.89169 12.6917C5.75835 13.6 6.40002 14.2333 7.30835 14.1083L9.81669 13.75C10.1667 13.7 10.6584 13.45 10.9167 13.2L17.4834 6.63333C18.6167 5.5 19.15 4.18333 17.4834 2.51666C15.8167 0.849997 14.5 1.38333 13.3667 2.51666Z"
            stroke="#292D32"
            stroke-width="1.5"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M12.425 3.45834C12.9833 5.45001 14.5417 7.00834 16.5417 7.57501"
            stroke="#292D32"
            stroke-width="1.5"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      );
      break;
    case "round-cross":
      icon = (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
        >
          <path
            d="M10 18.3333C14.5834 18.3333 18.3334 14.5833 18.3334 9.99999C18.3334 5.41666 14.5834 1.66666 10 1.66666C5.41669 1.66666 1.66669 5.41666 1.66669 9.99999C1.66669 14.5833 5.41669 18.3333 10 18.3333Z"
            stroke="#292D32"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M7.64166 12.3583L12.3583 7.64166"
            stroke="#292D32"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M12.3583 12.3583L7.64166 7.64166"
            stroke="#292D32"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      );
      break;
    case "copy":
      icon = (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0_2207_8894)">
            <path
              d="M6.66699 13.3332H4.52533C2.61699 13.3332 1.66699 12.3832 1.66699 10.4748V4.52484C1.66699 2.6165 2.61699 1.6665 4.52533 1.6665H8.33366C10.242 1.6665 11.192 2.6165 11.192 4.52484"
              stroke="#292D32"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M15.4753 18.3332H11.6669C9.75859 18.3332 8.80859 17.3832 8.80859 15.4748V9.52484C8.80859 7.6165 9.75859 6.6665 11.6669 6.6665H15.4753C17.3836 6.6665 18.3336 7.6165 18.3336 9.52484V15.4748C18.3336 17.3832 17.3836 18.3332 15.4753 18.3332Z"
              stroke="#292D32"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M12.3917 12.5H15.1083"
              stroke="#292D32"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M13.75 13.8583V11.1417"
              stroke="#292D32"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </g>
          <defs>
            <clipPath id="clip0_2207_8894">
              <rect width="20" height="20" fill="white" />
            </clipPath>
          </defs>
        </svg>
      );
      break;
    case "delete-2":
      icon = (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
        >
          <path
            d="M17.5 4.98333C14.725 4.70833 11.9333 4.56667 9.15 4.56667C7.5 4.56667 5.85 4.65 4.2 4.81667L2.5 4.98333"
            stroke="#292D32"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M7.08331 4.14167L7.26665 3.05001C7.39998 2.25834 7.49998 1.66667 8.90831 1.66667H11.0916C12.5 1.66667 12.6083 2.29167 12.7333 3.05834L12.9166 4.14167"
            stroke="#292D32"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M15.7084 7.61667L15.1667 16.0083C15.075 17.3167 15 18.3333 12.675 18.3333H7.32502C5.00002 18.3333 4.92502 17.3167 4.83335 16.0083L4.29169 7.61667"
            stroke="#292D32"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M8.60834 13.75H11.3833"
            stroke="#292D32"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M7.91669 10.4167H12.0834"
            stroke="#292D32"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      );
      break;
    case "lock-2":
      icon = (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M14.375 6.5625V4.96094C14.375 2.57031 12.4297 0.625 10.0391 0.625H9.96094C7.57031 0.625 5.625 2.57031 5.625 4.96094V6.5625H2.5V19.375H17.5V6.5625H14.375ZM6.875 4.96094C6.875 3.25781 8.26172 1.875 9.96094 1.875H10.0352C11.7383 1.875 13.1211 3.26172 13.1211 4.96094V6.5625H6.875V4.96094ZM16.25 18.125H3.75V7.8125H16.25V18.125Z"
            fill="#232323"
          />
          <path
            d="M9.375 13.8945V15.625H10.625V13.8945C11 13.6797 11.25 13.2734 11.25 12.8125C11.25 12.1211 10.6914 11.5625 10 11.5625C9.30859 11.5625 8.75 12.1211 8.75 12.8125C8.75 13.2734 9 13.6797 9.375 13.8945Z"
            fill="#232323"
          />
        </svg>
      );
      break;
    case "unlock":
      icon = (
        <svg
          width="15"
          height="18"
          viewBox="0 0 15 18"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M0.670455 6.67045H3.32955V4C3.32955 2.89773 3.78409 1.89773 4.51136 1.17045C5.22727 0.454545 6.23864 0 7.32955 0C8.43182 0 9.43182 0.454545 10.1591 1.17045C10.8864 1.89773 11.3295 2.89773 11.3295 4V4.67045H10V4C10 3.27273 9.70455 2.60227 9.21591 2.11364C8.73864 1.63636 8.06818 1.32955 7.32955 1.32955C6.60227 1.32955 5.93182 1.63636 5.45455 2.11364C4.96591 2.60227 4.67045 3.27273 4.67045 4V6.67045H10H11.3295H14C14.3636 6.67045 14.6705 6.96591 14.6705 7.32955V17.3295C14.6705 17.7045 14.3636 18 14 18H0.670455C0.295455 18 0 17.7045 0 17.3295V7.32955C0 6.96591 0.295455 6.67045 0.670455 6.67045ZM8 12.9886V13.75C8 14.125 7.70455 14.4205 7.32955 14.4205C6.96591 14.4205 6.67045 14.125 6.67045 13.75V12.9886C6.60227 12.9432 6.53409 12.8864 6.47727 12.8295L6.46591 12.8182C6.25 12.6023 6.11364 12.2955 6.11364 11.9659C6.11364 11.625 6.25 11.3295 6.47727 11.1023C6.70455 10.8977 7 10.75 7.32955 10.75C7.67045 10.75 7.97727 10.8864 8.19318 11.1023C8.42045 11.3295 8.55682 11.625 8.55682 11.9659C8.55682 12.3068 8.42045 12.6023 8.19318 12.8295C8.13636 12.8864 8.06818 12.9432 8 12.9886ZM13.3295 8H11.3295H10.6705H3.32955H1.32955V16.6705H13.3295V8Z"
            fill="black"
          />
        </svg>
      );
      break;
    case "arrow-left":
      icon = (
        <svg
          width="24"
          height="24"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M7.9751 4.94165L2.91677 9.99998L7.9751 15.0583"
            stroke="#888888"
            stroke-width="1.5"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          ></path>
          <path
            d="M17.0835 10H3.0585"
            stroke="#888888"
            stroke-width="1.5"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          ></path>
        </svg>
      );
      break;
    case "clipboard-text":
      icon = (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="none"
        >
          <path
            d="M6 9.1499H11.25"
            stroke="#888888"
            stroke-width="1.5"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M6 12.1499H9.285"
            stroke="#888888"
            stroke-width="1.5"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M7.5 4.5H10.5C12 4.5 12 3.75 12 3C12 1.5 11.25 1.5 10.5 1.5H7.5C6.75 1.5 6 1.5 6 3C6 4.5 6.75 4.5 7.5 4.5Z"
            stroke="#888888"
            stroke-width="1.5"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M12 3.01514C14.4975 3.15014 15.75 4.07264 15.75 7.50014V12.0001C15.75 15.0001 15 16.5001 11.25 16.5001H6.75C3 16.5001 2.25 15.0001 2.25 12.0001V7.50014C2.25 4.08014 3.5025 3.15014 6 3.01514"
            stroke="#888888"
            stroke-width="1.5"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      );
      break;
    case "arrow-bottom":
      icon = (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
        >
          <path
            d="M13.3538 6.35403L8.35378 11.354C8.30735 11.4005 8.2522 11.4374 8.1915 11.4626C8.13081 11.4877 8.06574 11.5007 8.00003 11.5007C7.93433 11.5007 7.86926 11.4877 7.80856 11.4626C7.74786 11.4374 7.69272 11.4005 7.64628 11.354L2.64628 6.35403C2.55246 6.26021 2.49976 6.13296 2.49976 6.00028C2.49976 5.8676 2.55246 5.74035 2.64628 5.64653C2.7401 5.55271 2.86735 5.5 3.00003 5.5C3.13272 5.5 3.25996 5.55271 3.35378 5.64653L8.00003 10.2934L12.6463 5.64653C12.6927 5.60007 12.7479 5.56322 12.8086 5.53808C12.8693 5.51294 12.9343 5.5 13 5.5C13.0657 5.5 13.1308 5.51294 13.1915 5.53808C13.2522 5.56322 13.3073 5.60007 13.3538 5.64653C13.4002 5.69298 13.4371 5.74813 13.4622 5.80883C13.4874 5.86953 13.5003 5.93458 13.5003 6.00028C13.5003 6.06598 13.4874 6.13103 13.4622 6.19173C13.4371 6.25242 13.4002 6.30757 13.3538 6.35403Z"
            fill="#101010"
          />
        </svg>
      );
      break;
    case "assign-content":
      icon = (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M12 12C14.7614 12 17 9.76142 17 7C17 4.23858 14.7614 2 12 2C9.23858 2 7 4.23858 7 7C7 9.76142 9.23858 12 12 12Z"
            stroke="currentcolor"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M3.41003 22C3.41003 18.13 7.26003 15 12 15C12.96 15 13.89 15.13 14.76 15.37"
            stroke="currentcolor"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M22 18C22 18.75 21.79 19.46 21.42 20.06C21.21 20.42 20.94 20.74 20.63 21C19.93 21.63 19.01 22 18 22C16.54 22 15.27 21.22 14.58 20.06C14.21 19.46 14 18.75 14 18C14 16.74 14.58 15.61 15.5 14.88C16.19 14.33 17.06 14 18 14C20.21 14 22 15.79 22 18Z"
            stroke="currentcolor"
            stroke-width="1.5"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M16.4399 18L17.4299 18.99L19.5599 17.02"
            stroke="currentcolor"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      );
      break;
    case "mac":
      icon = (
        <svg
          width="512"
          height="512"
          viewBox="0 0 512 512"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M395.742 272.026C395.074 207.144 448.641 176.095 451.015 174.537C420.93 130.578 374.115 124.532 357.384 123.864C317.58 119.783 279.631 147.309 259.376 147.309C239.196 147.309 207.961 124.42 174.909 125.014C131.432 125.681 91.4054 150.313 68.9994 189.19C23.8535 267.537 57.4254 383.573 101.421 447.193C122.937 478.28 148.608 513.187 182.254 511.963C214.676 510.665 226.917 490.967 266.128 490.967C305.338 490.967 316.356 511.963 350.633 511.332C385.54 510.665 407.612 479.615 428.943 448.454C453.649 412.36 463.813 377.378 464.444 375.635C463.627 375.19 396.446 349.482 395.742 272.026ZM331.269 81.7597C349.112 60.1327 361.205 30.0107 357.904 0C332.122 1.03869 300.998 17.1013 282.487 38.7654C265.905 57.9441 251.475 88.5483 255.333 117.966C284.045 120.228 313.425 103.35 331.269 81.7597Z"
            fill="#030104"
          />
        </svg>
      );
      break;
    case "windwos":
      icon = (
        <svg
          width="512"
          height="512"
          viewBox="0 0 512 512"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M0 80V240H224V52L0 80ZM256 48V240H512V16L256 48ZM256 272V464L512 496V272H256ZM0 272V432L224 460V272H0Z"
            fill="black"
          />
        </svg>
      );
      break;
    default:
      icon = null;
  }

  return (
    <span
      style={iconStyles}
      className={`[&>svg]:!w-[100%] [&>svg]:!h-[100%] inline-block ${
        className ? className : ""
      }`}
    >
      {icon}
    </span>
  );
};

export default Icons;
